<template>
  <div class="drawingcanvas-wrapper">
    <div class="dc-inner-wrapper">
      <div class="dc-menu-bar">
        <a-dropdown :trigger="['click']">
          <a
            class="ant-dropdown-link"
            @click="e => e.preventDefault()"
          >
            File
          </a>
          <a-menu
            slot="overlay"
            style="min-width:200px"
          >
            <a-menu-item @click="modalnewproject = true">
              New
            </a-menu-item>
            <a-menu-item @click="modalopenfile = true">
              Open
            </a-menu-item>
            <a-menu-divider/>
            <a-menu-item @click="modalsaveproject = true">
              Save Project <small
                class="shortcut"
                style="float:right;margin-left:30px;"
              >.bsd</small>
            </a-menu-item>
            <a-menu-item @click="openimagesavemodal">
              Save as <small
                class="shortcut"
                style="float:right;margin-left:30px;"
              >.jpg /
                .png</small>
            </a-menu-item>
            <a-menu-divider/>
            <a-menu-item @click="modalimageimport = true">
              Import Image
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <a-dropdown :trigger="['click']">
          <a
            class="ant-dropdown-link"
            @click="e => e.preventDefault()"
          >
            Edit
          </a>
          <a-menu slot="overlay">
            <a-menu-item @click="historyRedo">
              Step Forward <small
                class="shortcut"
                style="float:right;margin-left:30px;"
              >Shift+Ctrl +
                Z</small>
            </a-menu-item>
            <a-menu-item @click="historyUndo">
              Step Backward <small
                class="shortcut"
                style="float:right;margin-left:30px;"
              >Ctrl +
                Z</small>
            </a-menu-item>
            <a-sub-menu
              key="test"
              title="Transform"
            >
              <a-menu-item @click="rotateimage(90)">
                Rotate 90° ↻
              </a-menu-item>
              <a-menu-item @click="rotateimage(-90)">
                Rotate 90° ↺
              </a-menu-item>
              <a-menu-item @click="rotateimage(180)">
                Rotate 180°
              </a-menu-item>
              <a-menu-item @click="flipimage('horizontal')">
                Flip Horizontally
              </a-menu-item>
              <a-menu-item @click="flipimage('vertical')">
                Flip Vertically
              </a-menu-item>
            </a-sub-menu>
          </a-menu>
        </a-dropdown>
        <a-dropdown :trigger="['click']">
          <a
            class="ant-dropdown-link"
            @click="e => e.preventDefault()"
          >
            Image
          </a>
          <a-menu slot="overlay">
            <a-menu-item @click="modalcanvassize = true">
              Canvas Size
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
      <div class="dc-options-top">
        <div class="dc-brush">
          <div
            v-show="actions === 'drawing'"
            ref="brushoptions"
            class="brush-options"
          >
            <a-popover
              trigger="click"
              placement="bottomLeft"
            >
              <template slot="content">
                <div id="brush-options-case">
                  <span>Size:</span><input
                    v-model="brushsize"
                    class="inp_number"
                    type="number"
                    min="1"
                    max="100"
                  >
                  <input
                    v-model="brushsize"
                    class="inp_range"
                    type="range"
                    min="1"
                    max="100"
                  >
                </div>
              </template>
              <button>
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgBAMAAAB54XoeAAAAHlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC3KG9qAAAACnRSTlMA/hKxffA311BeudL+agAAA9hJREFUeJytm81v00AQxa00pOlxCSZwM6KoVxYC5ZiAEOVGQAKOLjduuBVwDRJwJv8xiZ00/thZv3m7c0sl/zS78/btetZNkoAYnU9fhjzfiYUx6Soi78hsYpLFAy62QPM5Gm+wLIHmSSzgUcUz0zwS8HIHNHciAe0eGGnQ4xteJO0cH4BxBr2oAc1VOG8vmmiDHppGTIKBD5rA8EHbFjB00CPTjsBKH3eAgfJed4FpHgIsusCgQQ8dvKBBP3ICA4ysLZpd0O7dFc0u5iTwSAKydbmUgGbFAQsR+I3inYg8c5cCukUTMIkLGUj5YtOsIwBF0bBAWTTkHFoPkKny2MMzjwmgw6wPkRNAj2jMfYLnEw3lNm6zroKqsWfdcXZoIycomjWboGfdMSVOkl8y8B8FLCIn6BENl6AsmnsUT1535PlwICb4kUtQFA17lhPNmkxQFE2acTxxh2ffAc4E3pRMUBQNm6Bk1nTfQRINfbYWRMM3RqwbyOzFZQjrjn8RFYB0gkniLHLI+5NzDucBQFeVg95qXcckzvi/vvq+fdCxJ1PGf/rM7AyvM4mM8Q/elI+WhtJxG8JXT/ZZbeXWHjNh/KfLRjnXoQkeeNV7YXOf1/tqnVelE9bxGhedfIbtP2hiYE0jrlopqn31daumpZGOl42fmnho2lEa1VnjlyJGyw6wymk3aLWvurbMctZG1dTOlTznDlfVdbRd21rbald4F1WnZ/D7/FqboHToYLfgQSEAU85QxQTZhpmY4CYmDLGr6UCi9QEJou+VuJxHbWXWPUCT6i7LHKu4Q3yuAcqaqUWmANrIQG+j5yZyHOjrUlBAaMSKZquvS1ELXIq+7iAF9HUHKaCNDASnEC8KOIU4EFOhQoe+diMFLEBgBvLQmhg0wT6z3keKAr0t4FpMUSC4TvCzF1pk+KxURAbKzbJWoD1/z+VQM26DQHQlm3cg8BYKRE/s7YtyMeYgEFUN7A0WBWYgsAB56EKBZYjqGpYhqmvUvOA7VdS8YNXAMsxBIOqGsL1Gd0MLAlGvgXWNWgOs6xwEYqdrxQ6F6hru8aF+DfdDUF3nKBDUNd5gAXX9HgZaDDiHgUuIBy9k9GyIfygAyhAfMSZDRRMNOzYo+qSeq+NDaDrNkAw1vfolApzjPEg1mrYhVGRFgtBbnqqvCdREd9tR9AN/aHjAQUnXyO0/1yibm71TqGy/er/LKXnK7+H7VKj+vr5ng5qslLyeEc8yJc8/4gnx7wRWxqUv1On5tpPpLNfjZBFeXxDZJdIMfph9oWjOy5NPswuWtok/ddLPp7O3fzOa9R+zT4BdqVJm+AAAAABJRU5ErkJggg=="
                >
                <span>▼</span>
              </button>
            </a-popover>
          </div>
          <div
            v-show="actions === 'erase'"
            ref="eraseoptions"
            class="erase-options"
          >
            <a-popover
              trigger="click"
              placement="bottomLeft"
            >
              <template slot="content">
                <div id="erase-options-case">
                  <span>Size:</span><input
                    v-model="erasesize"
                    class="inp_number"
                    type="number"
                    min="1"
                    max="100"
                  >
                  <input
                    v-model="erasesize"
                    class="inp_range"
                    type="range"
                    min="1"
                    max="100"
                  >
                </div>
              </template>
              <button id="erase-opt">
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgBAMAAAB54XoeAAAAHlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC3KG9qAAAACnRSTlMA/wt4ib1D890lKFtKwwAABAFJREFUeJytm01vEzEQhlcpjdTjQEtyXAkKPVIJkLgl3LgRQMAxRUXhSITKx7EgIXHjAKI/l268m+zaY8879szRzT59dtee2GOnqtQxevj2y9dXT/QXRuLOgjZx8c6G935NbUxem/CoFz9qWx7RL2MeTZZlvD3y43MZ8DQAlimGgkS3bAWvY2YrSHRoLEj0wlaQ6Ki2FcxWjAkSTX/bChL9tBXM7N0JwawBmBK8jge2ghkDUBDUD0BBUN27RUFt7xYFlYqAoO7rBRBUDUBIUPMUIUFFpgUFaYLeMyhI9NxWkOi2sSAdGQsSQQ8RF8QyhEaQPhoLIm/FCR6CQCDNOsEZCJRfcytYgcApKogCJ6ggCiRU0Aq4FbQCbgWNgDtBI+BOEAbWoKANsCdoAuwLmgD7ghbAgaAFcCBoABwKGgCHguVAT7Ac6AkWDz1fsBjoC5YCA8FSYCBYCAwFC4GhYBmQESwDMoJFQE6wCMgJlgBZwRIgK1gA5AULgLxg/nQuIogCwwlnRBAFBlPimCAKvIkKokB/sRcVRIFL77KzmCAI9FVGlzFBEPjNu+pGVBAE+vWqf1FBDDitvasWTStfiYCA/kpv3DRG6gZZd7zfNEaWfwgvuHTTab7nA4MS4qJpXWYDw7Vy0xpbn8o8pgzL/xsUyFRhm+ZYKSdHcHMR04wBuTJx0x7hiaUMttSXAkrFFrYYmQIKinwtMglMK/LDIQlsky8fkXpuGjhex4GRWmkaWK20ghIwrhgr5grAqGK0Ii4BY4qz2AUSMKIYLzaLwINLlaAMrK4YXqJkKAM5xcTekQysTjSCCHC08IHLMmB17PGS228I0FNMbxAiQE8xvT8IAQeKwg4mBBwo+vPBLGBPUdqEwoDttLQJaZsMBFbzTrA2AnaK4iYZCmwV5Z1GJVDexdPdMrAVqnspwDajqtsgu4wg0AnOzID7sKAqOUCHBhTpCzszgAA1goqvAHBTFQA6QfRkCAA8BhL/LtYiUCdYNdOCOvkJneBm8ThLfcDVJPCzNXPpa+cESvy7OBPSupsqKY5H3BeykpvMRVboXOyn86YT1BwxGacf0RWaV3cxT71EN2XXHdPZPET6xP9xpRds75nvizmCXXZns/EKTvz9aGdWzH05QfVJwzZ9MjeWJ7idtgSKTjDntOYpr7hSJH5Oxe/dY8U3kx8fiMkAznuZBTxYhEl0T5dXvXBdZzAAT3V51YvR3PcpE+yu7wmVCVZdH9m+07+Fgtuu0/a6P9xrV4ZLpUcbxjnbMZXRDenH9b1HbiyKSxIh/FVx/vHjLuZDXvbp4214xb2npTyv5mPxc4Jxr6CSdfI4iLtrS78m2l9kTJ8Z8a574/kbuniZMUL+A7jEhWh03/9rAAAAAElFTkSuQmCC"
                >
                <span>▼</span>
              </button>
            </a-popover>
          </div>
          <div
            v-show="actions === 'drawing'"
            ref="coloroptions"
            class="colors"
          >
            <a-popover
              trigger="click"
              placement="bottomLeft"
            >
              <template slot="content">
                <colorpicker
                  style="margin: 0 auto"
                  value="black"
                  @input="updateDrawColor"
                />
              </template>
              <div
                id="activeColor"
                :style="{ background: activecolorcode }"
              />
            </a-popover>
          </div>
          <div
            v-show="actions === 'shape'"
            ref="selectshape"
            class="shape-options"
          >
            <a-popover
              trigger="click"
              placement="bottomLeft"
            >
              <template slot="content">
                <div id="shape-options-case">
                  <div class="shapes-wrapper">
                    <div
                      v-for="(shape, index) in shapes"
                      :key="index"
                      class="shape"
                      :class="{ 'active': (activeshape === shape.id) }"
                      @click="selectshape(shape.id)"
                    >
                      <svg
                        class="shapes-thumb"
                        height="50px"
                        :view-box.camel="'0 0 ' + shape.width + ' ' + shape.height"
                      >
                        <path :d="shape.path"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </template>
              <button id="shape-opt">
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgBAMAAAB54XoeAAAAHlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC3KG9qAAAACnRSTlP+AO4HZ8U7G5SiAHBLPQAAA6lJREFUeJzt2r9u4kAQBvAVAoeUvuSSuy4REn2uSrl+g7iixXmCo0gP4gWONz4HjMe7s7N/ZiZdvhp+ivR9gt1gU+fl9Zj5QpP3sse3xU4VfDdmrQnemz6NHni3/wSXL2rghzlnowU+PF3AWacEWjNkrgO+mjEZY0yDj28AZowxDb6bSdJjTIL3xklyjCnwMkFIcowp8MN4SY0xAV4nCEmNMQFa30uOMQ6+Yi81xig4nWDuGKPge8hLjDEG3oe9+BgjoD9BSGyMERBNEBIZIw3iCUIiY6RBS3uxMZJgcIIQcowUGJ4ghBwjBRIThFBjJEByghBijGGQniCEGGMYjEwQEh5jEIxNEBIeYxC0OR4xxhCYmCAkNMYAmJogJDTGAJicICQwRgxmTBCCx4jAnAlC8BgRmDVBCBqjD+ZNEILG6IO2zMNj9MDsCUKOMTB/ghBvjC5YMEHImgaLJghpKLBsghBnjFOwcIKQTRgsnSBkOsYJaLmeM0YAGROEHDHImSAExjiCrAlC1j7InCCkcUHuBCHXMRrhBCGbKcifIGQYo5FOEDIHUDRByPEKyiYIOY/RyCcIWV9A8QQhzSconyCkH6PRmCBkUxuNCUJmnbGaXj9GozSZaxb6f+EfXXBlfumCB/OoC3amVm1l0Q/baoLzHlRtZdWDqq0celC1ld3nx5diK4vz5+FWD6zO4A898PlLPrE1W9ldvqT+aXm3w7feVgusBvCnFtgOoForzQDePel4s5fr2UapldvxsLTVAasRVGqlHUGlVpoR1Gnl3Mlwgt1rgMvJkfivBlhNQJVW2gmo0kozATVauXRyvfjs5eDSuUkptHLjgAqttA74IAc7B6yfpN6sdkErBeceKG7lxgN/S8GTB4pb6TxQemRa1D5oZeAcgcKD7AqBwlZOCBS20iFQ1srYyQS0EnAeAEWtrAKg6HpxCICig2wXACWtQCdf+S9TSSurICho5RAEBa3sgiC/lUknDrjlghUBsi99zwTIPjI1BMhuZUeA3OvFbU2BWx5YkSDzyNSSoPZPSMyD7HB0DYG8VpxOPHDLAasIyGqljYCsVpoIyGnF7cT/sXVfDi7rGMg4yFZRkNFKGwUZrTRRsLwVrxP0k/q+FPQ6QWBxKzcJsLiVNgEWH2RTjyWUXvpm/vsRaMtA9MwNAgtb8TvBYOH14pQEC1tBzy3h522KjkwL9HYM2hIQPweFwaKD7CoDLGrllAEWtYKfJUs/7VyYb/AbZOQ/D7t8kpmFSS8AAAAASUVORK5CYII="
                >
                <span>▼</span>
              </button>
            </a-popover>
          </div>
          <div
            v-show="actions === 'shape'"
            class="shape-fill-color"
          >
            <a-popover trigger="click">
              <template slot="content">
                <colorpicker
                  mode="hex"
                  style="margin: 0 auto"
                  value="black"
                  @input="changefillcolor"
                />
              </template>
              <div
                id="shape-fill-active"
                :style="{ background: shapeFill }"
              >
                <div/>
              </div>
            </a-popover>
          </div>
          <div
            v-show="actions === 'shape'"
            class="shape-fill-color"
          >
            <a-popover trigger="click">
              <template slot="content">
                <colorpicker
                  mode="hex"
                  style="margin: 0 auto"
                  value="black"
                  @input="changestrokecolor"
                />
              </template>
              <div
                id="shape-stroke-active"
                :style="{ background: shapeStroke }"
              >
                <div/>
              </div>
            </a-popover>
          </div>
          <div
            v-show="actions === 'shape'"
            class="shape-stroke"
          >
            <label for="strokesize">Stroke:</label>
            <input
              id="strokesize"
              v-model="shapeStrokeSize"
              type="number"
              class="inp_number"
              min="1"
              max="100"
            >
            <a-popover
              trigger="click"
              placement="bottomRight"
            >
              <template slot="content">
                <input
                  v-model="shapeStrokeSize"
                  type="range"
                  min="1"
                  max="100"
                >
              </template>
              <button class="btn-arrowdown">
                <span>▼</span>
              </button>
            </a-popover>
          </div>
          <div
            v-show="actions === 'text'"
            ref="texttool-font"
            class="texttool-font"
          >
            <a-dropdown :trigger="['click']">
              <button>
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgBAMAAAB54XoeAAAAHlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC3KG9qAAAACnRSTlMA/wxi9s87IauL8Nu1UwAAAXpJREFUeJzt2j1LxEAQBuAh4XKmjOZAu3gc1p4IahltLP0AP7rgB1raaH0H/gBB/L+Ch0pmdrNjZsEr3red2SfJ7qbaJUKQJUkRKQABxgPLq/eHsfdhP4Xk5eBVBV7fdG76VvH2NAge7wT+onZ1+BEAzyvmBUCi/U7wgreHQXrsAI+kFwbp3guOml4g7frAS0ezBsxqNziqeoL07AbPXL0qcFi7wPKpN0h3LnDN2aoDUxc4M4A0l6Dni5XgRILr7k4lmEvQM4VKMKkFeGgCF5PYGnRiA6cCnNnAiQC3beAgNpgLsLGBqQA9+1oLZgKsbGDSUesF6gMQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIMDYYMLBatnAIQd9Z6jaZLHBlINNbNB3sK1NHhsccPDNCG5y0Hd9QZspB1eN4JyDvisgynzf9fmN+yKSOivcs66KmMKi2LB4YlsbX3FLLMnXLO6Nw0PbWQwsxYLw/BEMByBABPm/fAJPo/BYXTJS5AAAAABJRU5ErkJggg=="
                >
                <span>▼</span>
              </button>
              <div
                slot="overlay"
                class="drawingcanvas_dropdownmenu"
              >
                <div class="drawingcanvas_fonts">
                  <ul>
                    <li
                      v-for="(font, index) in fonts"
                      :key="index"
                      :class="{ 'active': font === fontfamily }"
                      @click="tooglefont(font)"
                    >
                      {{ font }} <span
                        class="preview"
                        :style="{'font-family': font}"
                      >Preview</span>
                    </li>
                  </ul>
                </div>
              </div>
            </a-dropdown>
          </div>
          <div
            v-show="actions === 'text'"
            class="toolbuttons"
          >
            <a-dropdown :trigger="['click']">
              <div
                class="colorbutton"
                :style="{ background: texttoolColor}"
              />
              <a-menu
                slot="overlay"
                style="padding:0px;"
              >
                <colorpicker
                  mode="hex"
                  style="margin: 0 auto"
                  value="black"
                  @input="updateFontColor"
                />
              </a-menu>
            </a-dropdown>
          </div>
          <div
            v-show="actions === 'text'"
            ref="texttool-menu"
            class="texttool-menu"
            style="margin:0px 4px;"
          >
            <label for="fontsize">Size:</label>
            <input
              id="fontsize"
              v-model="texttoolSize"
              type="number"
              class="inp_number"
              min="1"
              max="250"
            >
            <a-popover
              trigger="click"
              placement="bottomRight"
            >
              <template slot="content">
                <input
                  v-model="texttoolSize"
                  type="range"
                  min="1"
                  max="500"
                >
              </template>
              <button class="btn-arrowdown">
                <span>▼</span>
              </button>
            </a-popover>
          </div>
          <div
            v-show="actions === 'text'"
            class="toolbuttons"
          >
            <div
              class="colorbutton"
              :style="{ background: textstrokeColor }"
            >
              <span class="colorinner"/>
            </div>
          </div>
          <div
            v-show="actions === 'text'"
            ref="texttool-menu"
            class="texttool-menu"
            style="margin:0px 4px;"
          >
            <label for="fontsize">Border:</label>
            <input
              id="fontsize"
              v-model="texttoolStroke"
              type="number"
              class="inp_number"
              min="0"
              max="200"
            >
            <a-popover
              trigger="click"
              placement="bottomRight"
            >
              <template slot="content">
                <input
                  v-model="texttoolStroke"
                  type="range"
                  min="0"
                  max="200"
                >
              </template>
              <button class="btn-arrowdown">
                <span>▼</span>
              </button>
            </a-popover>
          </div>
          <div
            v-show="actions === 'text'"
            class="toolbuttons fontweight"
          >
            <button
              :class="{ 'active' : fontbold }"
              @click="fontbold = !fontbold"
            >
              <img
                src="data:image/png;base64,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"
                alt="Bold"
              >
            </button>
            <button
              :class="{ 'active' : fontitalic }"
              @click="fontitalic = !fontitalic"
            >
              <img
                src="data:image/png;base64,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"
                alt="Italic"
              >
            </button>
          </div>
          <div
            v-show="actions === 'text' && addtext"
            class="texttool-confirm"
          >
            <button>
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAgMAAAAhHED1AAAADFBMVEUAAAAAAAAAAAAAAAA16TeWAAAABHRSTlMA/8ky3+Rv8AAABVtJREFUeJyt289x22gMxmGNdNLs0F1oz7nw4Nk6mN0Z70EF+JAS1IT6UAlugunAtxQRSdYfit+LFz+slkcM/A3xxJZIAFks/rfrj0ryXyL250fhgJ8ieX/gP78a2uTl8M4P6ETyenjjB/QieTN8/8AHjCJ5P4i6gms1tMnLYwwjdCJ5fYxhhF4kb44xjDCK5CMBRjgRzJOX5xhE6ETy+hyDCL1I3pxjEGEUyWcCiPBF8Ji8vMQQQieS15cYQuhF8uYSQwijSL4QIIQrwTR5eYsBhE4kr28xgNCL5HsMIIwi+R7LEe4E9+RpLEXoRPI0liL0InkaSxFGkTyNZQjTcq/Jj7EEoRPJj7EEoRfJj7EEYS+SHwgShOXQJq9mMYuwFsndLGYRNiK5n8Uswl4kzwgswpzglDwnsAhzglPySxMzCHOCU3J7qEGYEwzDv+IOYoSWYPixWLWnhgjt3Q7Hu/3kCC3B38foK0dQBIsCgiRYFBA0QQFBExQQNAFHCAg4QkSAESICjBARUISQgCLEBBAhJoAIMQFDMAQMwREgBEeAEBwBQbAEBMETAARPABA8QY6QEOQIGUGKkBGkCBlBhiAI5n8sHoF8hVsE9VwwvyyCvT2AAAg8AnuKMQiEwCIQAoeACBwCfZALERiBQWAEMQIkiBH4s2yAQAlCBEoQIWCCCKHyOC8ROEGAwAk0QoFAI5TeaBRChUAiVAgkQoVAIpQIFEJz+QZDi9BcvsUBEHyTJUfI2jwpQtZoShGyVleKkDXbMoS83Zcg5A3HBCFveSYIedPVI5C2r0UgjWeLQFrfFoE03x0Ca/8bBDaAMAhsBGIQ2BAmRqBjoBCBDqJCBDoKCxHoMC5C4OPAAIEPJAMEPhINEPhQViMUJqIaoTCT1QiFqbBGKMylJUKFQCJUCCRChaBt+Q/zfsF/uINt6QBh8E/l5+W/QuUA+XuwKxwgfxO3hQPk30IBIfhr5AcEnwc7fEDwibTFBwSfiRgh/FSmB4TfCzt4QPjNtIUHhN+NEMF8O7MDzPPBDh1gnlC26ADzjIQQ7FMaOcA+J+7AAfZJdQsOsM/KACF5Ws8PSN4XdukByRvL9jkCgJC+tT1JkCOkb64ZQvrunCCAt/cnCTIE0MHwCKCHYhFQF+dJAo+AOlkOQfTS2pBBUN08cVMlgoOIxQiqoynuKkaQPdUCgu7qFhB0X7mAoDvbBYSgt44Rou4+RojmCxghmnBghHDGAhHiKQ9EiOdMECGedEEEM2tDCG7ahxDcvBEhuIknQrAzV4Dgp74Awc+dAYKffAOEZPaeImTT/xQh2z9IEbINiBQh3cFoEx72B/ItkPYWHzYY8j0UkfFhz593jcQ9TrsyYBfHIpBtIItA9pEsAtmIsghoJ8sgsK0wg8D20gwC24wzCHA3L0Sg24EhAt1PDBHohmSIgHc0AwS+JRog8D3VAIFvygYIhV1diVDZFpYIlX1liVDZL5AI7YaDaaK3CO9izcQ00VuEg9jyMHOEBuFU7hzBzREahFO5cwQ7R5gjnMvdixhFOJe7ETGI8FXuWsQgwle5SxGDCJdy9yLGEC7lbkQMIVzLXYtYdD0gXMtdilh4TRFu5e5FLLp6Ve5GxKJrMoG6l7sWseia/J+PNxEEA7VRlTuKWHTdEQ4iCGaKN4RpuZ2IRdet3jcRRDPFa73vIohmitd6DyKIxqqdKrfDBLd630QQjlVHVe6ICa71HkQQTpY7VW6HCS71zstdcYKveptyPwuT5V6V+1oYrneq3JfCcH2lyl3tC8P1UZX7WRiu96rc18J+QafKfRGx6FrVdgnE9evZA749e8D9+g2w4Fwzf7ERbQAAAABJRU5ErkJggg=="
                alt="Cancel"
                @click="TextToolAction('cancel')"
              >
            </button>
            <button>
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAgMAAAAhHED1AAAADFBMVEUAAAAAAAAAAAAAAAA16TeWAAAABHRSTlMA/95wQrXL2gAAA6VJREFUeJzt27uN3DAQBmBhN3Igd7ElMDDgNnh7gDdgARdcCWpi+3AJakJwBc6dOLek067ImeFoHoltcLLDSf+Jn0WJGtBd16pVq1atWrVq1eo/ql/O8883Z0B/dQaEOPgCpphc559jfHUF9DG+uAJCjD6EaQ5IjvNnAh9CvwS8jPaAhSDG7/aAaQ14M5+/EsT4zRzQfwTE0RoQtoB3a8C0BVin9EYQo3VKPwjMCOEZkGwB0zPAdjc/CaxTeicwTumQBSRLwJQFWBAyAhtCTmCa0qEIMEzpexGgn9KnWJY64JM34OINuDsDIIH6kQAJ1A8lSKB+LEKCUXl+I2gEfyNB0gZAgkF5PiRQvxQggfq11AgaQSPoGkHXCLpG0P0rBFx3TkLAduckBGx3TkLwhVkwiQh+Mks2EcGdWTFJCE7cmk1CsFzlWDlfRLBcZe0zWDQRlqusfQZDAuq49Sprn8GQgLrS9Sor7T1EQB12qUYvt1hZ5IXeq4NbbrFjAq69d5YQ9MzoPksIAhMuIpiY4SkIyHQNAXmXiwj2YQ7M7xiCfZiJ+R1DsA8TTTQRQXazIwQRQT7fBwtBPt8hgoSgmO8AARFQj+5ivgMESEA+N8tHXokACcgnd/nIKxEgAfnuKIdZIOgJAIKIoAfH5AgiggAOyhFEBBM4KEMQEaCADEFEgIaQIYgIEGKGICIoO90FgoyAQZAR4JE+EaBObQmD/tADAV5abRGFhvpawaku4yD2hoD+eSoEVQQpQRVBSkAg3HQEGOGqIyAQRhUBgfCuIujwSvCmI8Br0auOAK+G56M1BHgxOl+vioBA0BEQCIhg4AMQwm/w89HXNkKAdfi1DRFgpaMAiKAkIBB0BIcIgoYDj3BIcIRwSHCAIOm5sAiinguHkCQBHMIgCWAQZG0nBkHYdpp8BMRaR0dAPEZ1BMSDXElQR0jSgBrCIA2oIMibjxUERfORRkjyABphkAeQCJr+K4mg6r9SCEkTQCEMmgC01tG2oNGCT92Chgs+dQsaLfi0LWiEoO3C15b+8oIISRsAEQZtAEDQ71cCCIYdU+UbzrBdqXzDGTZMlS2ZUR9QvOZNWyBzBNMmzBzBtA00b82NloAMwbgL9OIjyBGMO2FPToIdwbwR9uIj2BHMm4FPToIHgn0v8IZg3428IZi3Aj8QRnvAiuDa3B+ifS/yWr2P4GOtM3oC5rWO8/83BB/BguAiWBBGX0D3w3l+99Ub0KpVq1b6+gOHPSRKOIZnzgAAAABJRU5ErkJggg=="
                alt="Confirm"
                @click="TextToolAction('draw')"
              >
            </button>
          </div>
          <div
            v-show="actions === 'fill'"
            class="toolbuttons"
          >
            <div
              class="toolicon"
              style="padding:7px 6px 6px 6px;"
            >
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgBAMAAAB54XoeAAAAElBMVEUAAAAAAAAAAAAAAAAAAAAAAADgKxmiAAAABnRSTlMA/rpXGges1xAeAAAFOElEQVR4nO2azWKjOgyFNYHsC2n3gXT2cTLd05l795227/8sF4ItS7IMtsPdRZv8wUGfdSI7JgCPeMQj/pf4tbHert1Wr+6a86aCl6Y5bKlXNWMM2+mNwGMctxO8THobMt+Ax9iqLDPwGM8bCV6sXrORFR3wVsz7zgtuUpbfXq9ph/x8/lwv/RjXq20GBDjfivW1p+n0bxw4l7m6NCLOHDivLHUg17xK4Pm9tPjqAr32AwDfbY19TNSTZAHwOe/rF+IK4BMmm1QWTW8CNvhiAHj3T0t4BTD4dI+TH/rTNS6s6o2MVUdeAOZ7sPRtbBqswvrOYAx4jB2my64jY6/phcBj1PblK15KVVwHxrpanRY+xaUYsKanAZNjzzV+9hEImkaJ8cKYBG0waEWjfDjHp9SywHUIDMSKlfZptCIRYKBWxK/CwAXVBBnwT3Y8MiOBKIuWYBQYqBWdCY7q52nAQK3o+iefqk2otwQMxIoOjyFoHlwCZsw2W3aIUpJFYPC2OLh0mKBCfKZ5B8BAu+J7MIZ1qHdYBgZqxc4+huPBgS/0hRKOuWoCwfdA8LgGDH7gDY5RfAjXgYOBou1mvwwcnS5ZHvSygQt/JgCDGPrn2AfzxfarwCA6FOX4S97vu1RgYMVkHRvHoj2NWt9vFHhxSUTGioG4zDGbJGB6pmheQYvE+W8RmFqLEe9lNhJ4XBz/Cic1gD8+QdYMyVJFBb69bvsrX3B8sUXzWRMcIsDY29ppBT9HT9WkoLVhK/SxwqZZj4Mi6N4z8iB1ySOCNaQf7Pywwgl6avOaC+VXRmjpJEHKbOa3XnTgNGRWFqvxxIDJAUYVkPGqCirAkVUKxsme3qqCmAz9VVMvMI/LazJBB4IaMNyW+rH0BjZB80F/0oFtltdQtD2dqUu8FVHQA2utAL6n38/24L4/Yb+QvcALYoJLTWv/zxj8LcmMgq6cufsJnyIPFHQTbe4eClkrckEcxNw9FMMT8YJueHOZhRW9oHuqVzkeworGCzpnHzNT5FYkgqXM3IpW8IU8z97CZMxW5NZg3fDGV0h6MCtSQTe8pVa8JcKmgHd6qYwwhPkHFXTDm7uF6cZq8M+f2aVyreiYj4HgjnySE8QrXLCWzSgx/vrTKj5qhVYkCxoh6MqSaUV32geuD7GuhVYkfuu4oGzAidFFBZ0DMq1IdgqMOL/MisYLyt+7ZVYkgjtJWGRFK/ikCbrGPRQKVlKwyIoEeR8U1ZWlUHAeM+33aY4V6QaTkYKucedYkQrugpPdvJhuRbZdXgWCwRItWXCYXtwIXzSAdCt+sjoaayAfdI5ICm6MXSDoGneqFUUZq3C4Mq0oB90E+1GZ9xiNOLzqg4V/lhXrhDb/O8eKKctzOnWnJrh8sEm3ots3WsZJtyLuKiwP+D7Vin4bZcUSrixrgvibc210Eq2IwCv7UMDXttHwwOv3It0CaLF2ycDg7XVcOMbvG6V8SROs6L7EaTdf5bZYGH7fKG22WLNilWpBF7yxh5EHDL5DRK6fCwwrVswGBiyLnkE28BQLViwA9mcpViwBhiUrIrB+MzgaJmJFv9eb+bNQ7Pm6qMuAwbcncV4pMODSjpfFAw/ZgtqKuxx4ChPmcgcw+Pn0gIprd+hWAvnc6f7/GiXAwG4J/QvfV7/JWwQMkT8YFANPEdl4LgSG2N74HX/VUm7v3gMM+v2A3A03FkpZ7vxvWpDiXcBaincBKyne/2c8fhPkXuApvqheuaVJ+Lst7dsWeqNit62e/dff7Sb0ZrGX91Ie8YhN4j9O2k4kglwzIwAAAABJRU5ErkJggg=="
              >
            </div>
          </div>
          <div
            v-show="actions === 'fill'"
            class="toolbuttons"
          >
            <a-dropdown :trigger="['click']">
              <div
                class="colorbutton"
                :style="{ background: globalcolorone }"
              />
              <a-menu
                slot="overlay"
                style="padding:0px;"
              >
                <colorpicker
                  mode="hex"
                  style="margin: 0 auto"
                  value="black"
                  @input="updateGlobalColorOne"
                />
              </a-menu>
            </a-dropdown>
          </div>
          <div class="undoredo">
            <button
              id="undo"
              title="undo"
              @click="historyUndo"
            >
              <a-icon type="undo"/>
            </button>
            <button
              id="redo"
              title="redo"
              @click="historyRedo"
            >
              <a-icon type="redo"/>
            </button>
          </div>
          <div
            v-show="actions === 'drawing'"
            class="brush-menu"
          >
            <button
              id="ruler-horizontal"
              :class="{ 'active' : rulerhr }"
              @click="ruler('hr')"
            >
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAbZJREFUeF7tmb1KA0EUhb+AoCCYRmz8ATubFIJN9AXEF7CwURCsjeA7WKi9IGIh5AUiPoEKghY+gIipTBMEwUJQbpiFsDDOFmpx52yZuWH3fvecM9lMjcyvWub9IwBSQOYEZIHMBaAQlAVkgcwJyAKZC0C7gCwgC2ROQBYIApgF9oBFYLwkildgbeizXWAjIpwL4Hho7RKYitRuAY9hrQGcRep++/7vwD1wCHRNAQvALVCPPEAXMEDFZV9sRWqPAshi+QWYidQuAzdhrQlc//P9+0DTAHRKEy4/h1cA1mfHABiJ2PStyDOAvgH4SmwEngEMfgkKgBTwMwFZwOk2OBi7MqBCCH4Cq8ATMAacA0sR19wBm8AHMA9cASOR2gPgJKztAPuRur+6f2UFuH5dqmIBAfBMQAqoEIKeBVBpGxQAzwSUAcqA9OuwZwcoBJUBygBlAD1g0nXSxZvrWQa0gfVMAbQNwHQ4lZnLDMIzsFIcjk4A2+FscNQ5CPu36gE4Bd50Oux82sn2pIAkIucFUoDzASfbkwKSiJwXSAHOB5xsTwpIInJeIAU4H3CyPSkgich5QfYK+Abyy5qjpbxgXgAAAABJRU5ErkJggg=="
              >
            </button>
            <button
              id="ruler-vertical"
              :class="{ 'active' : rulervr }"
              @click="ruler('vr')"
            >
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAIpJREFUWEftl8ENQEAURJ8auBH9iD70RCP0w5UWyB4cJOyuJRHMnuf/PzuZOUyE+5VADaRu6AYxABXQ2uYij6U9kHng9iBmNr9KYA48vo5ZP+mjgAi8RoEYmM765U4PJMD4JIGj20rBfxRQCpQCKaAUyANSQCmQB76rwOPltACagIZsiJt63tm6wgJbRi4hvQKN3wAAAABJRU5ErkJggg=="
              >
            </button>
          </div>
        </div>
      </div>
      <div class="workspace">
        <div class="dc-options-left">
          <div class="action-list">
            <label>
              <input
                v-model="actions"
                type="radio"
                name="actions"
                value="drawing"
              >
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgBAMAAAB54XoeAAAAHlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC3KG9qAAAACnRSTlMA/hKxffA311BeudL+agAAA9hJREFUeJytm81v00AQxa00pOlxCSZwM6KoVxYC5ZiAEOVGQAKOLjduuBVwDRJwJv8xiZ00/thZv3m7c0sl/zS78/btetZNkoAYnU9fhjzfiYUx6Soi78hsYpLFAy62QPM5Gm+wLIHmSSzgUcUz0zwS8HIHNHciAe0eGGnQ4xteJO0cH4BxBr2oAc1VOG8vmmiDHppGTIKBD5rA8EHbFjB00CPTjsBKH3eAgfJed4FpHgIsusCgQQ8dvKBBP3ICA4ysLZpd0O7dFc0u5iTwSAKydbmUgGbFAQsR+I3inYg8c5cCukUTMIkLGUj5YtOsIwBF0bBAWTTkHFoPkKny2MMzjwmgw6wPkRNAj2jMfYLnEw3lNm6zroKqsWfdcXZoIycomjWboGfdMSVOkl8y8B8FLCIn6BENl6AsmnsUT1535PlwICb4kUtQFA17lhPNmkxQFE2acTxxh2ffAc4E3pRMUBQNm6Bk1nTfQRINfbYWRMM3RqwbyOzFZQjrjn8RFYB0gkniLHLI+5NzDucBQFeVg95qXcckzvi/vvq+fdCxJ1PGf/rM7AyvM4mM8Q/elI+WhtJxG8JXT/ZZbeXWHjNh/KfLRjnXoQkeeNV7YXOf1/tqnVelE9bxGhedfIbtP2hiYE0jrlopqn31daumpZGOl42fmnho2lEa1VnjlyJGyw6wymk3aLWvurbMctZG1dTOlTznDlfVdbRd21rbald4F1WnZ/D7/FqboHToYLfgQSEAU85QxQTZhpmY4CYmDLGr6UCi9QEJou+VuJxHbWXWPUCT6i7LHKu4Q3yuAcqaqUWmANrIQG+j5yZyHOjrUlBAaMSKZquvS1ELXIq+7iAF9HUHKaCNDASnEC8KOIU4EFOhQoe+diMFLEBgBvLQmhg0wT6z3keKAr0t4FpMUSC4TvCzF1pk+KxURAbKzbJWoD1/z+VQM26DQHQlm3cg8BYKRE/s7YtyMeYgEFUN7A0WBWYgsAB56EKBZYjqGpYhqmvUvOA7VdS8YNXAMsxBIOqGsL1Gd0MLAlGvgXWNWgOs6xwEYqdrxQ6F6hru8aF+DfdDUF3nKBDUNd5gAXX9HgZaDDiHgUuIBy9k9GyIfygAyhAfMSZDRRMNOzYo+qSeq+NDaDrNkAw1vfolApzjPEg1mrYhVGRFgtBbnqqvCdREd9tR9AN/aHjAQUnXyO0/1yibm71TqGy/er/LKXnK7+H7VKj+vr5ng5qslLyeEc8yJc8/4gnx7wRWxqUv1On5tpPpLNfjZBFeXxDZJdIMfph9oWjOy5NPswuWtok/ddLPp7O3fzOa9R+zT4BdqVJm+AAAAABJRU5ErkJggg=="
              >
            </label>
            <label>
              <input
                v-model="actions"
                type="radio"
                name="actions"
                value="erase"
              >
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgBAMAAAB54XoeAAAAHlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC3KG9qAAAACnRSTlMA/wt4ib1D890lKFtKwwAABAFJREFUeJytm01vEzEQhlcpjdTjQEtyXAkKPVIJkLgl3LgRQMAxRUXhSITKx7EgIXHjAKI/l268m+zaY8879szRzT59dtee2GOnqtQxevj2y9dXT/QXRuLOgjZx8c6G935NbUxem/CoFz9qWx7RL2MeTZZlvD3y43MZ8DQAlimGgkS3bAWvY2YrSHRoLEj0wlaQ6Ki2FcxWjAkSTX/bChL9tBXM7N0JwawBmBK8jge2ghkDUBDUD0BBUN27RUFt7xYFlYqAoO7rBRBUDUBIUPMUIUFFpgUFaYLeMyhI9NxWkOi2sSAdGQsSQQ8RF8QyhEaQPhoLIm/FCR6CQCDNOsEZCJRfcytYgcApKogCJ6ggCiRU0Aq4FbQCbgWNgDtBI+BOEAbWoKANsCdoAuwLmgD7ghbAgaAFcCBoABwKGgCHguVAT7Ac6AkWDz1fsBjoC5YCA8FSYCBYCAwFC4GhYBmQESwDMoJFQE6wCMgJlgBZwRIgK1gA5AULgLxg/nQuIogCwwlnRBAFBlPimCAKvIkKokB/sRcVRIFL77KzmCAI9FVGlzFBEPjNu+pGVBAE+vWqf1FBDDitvasWTStfiYCA/kpv3DRG6gZZd7zfNEaWfwgvuHTTab7nA4MS4qJpXWYDw7Vy0xpbn8o8pgzL/xsUyFRhm+ZYKSdHcHMR04wBuTJx0x7hiaUMttSXAkrFFrYYmQIKinwtMglMK/LDIQlsky8fkXpuGjhex4GRWmkaWK20ghIwrhgr5grAqGK0Ii4BY4qz2AUSMKIYLzaLwINLlaAMrK4YXqJkKAM5xcTekQysTjSCCHC08IHLMmB17PGS228I0FNMbxAiQE8xvT8IAQeKwg4mBBwo+vPBLGBPUdqEwoDttLQJaZsMBFbzTrA2AnaK4iYZCmwV5Z1GJVDexdPdMrAVqnspwDajqtsgu4wg0AnOzID7sKAqOUCHBhTpCzszgAA1goqvAHBTFQA6QfRkCAA8BhL/LtYiUCdYNdOCOvkJneBm8ThLfcDVJPCzNXPpa+cESvy7OBPSupsqKY5H3BeykpvMRVboXOyn86YT1BwxGacf0RWaV3cxT71EN2XXHdPZPET6xP9xpRds75nvizmCXXZns/EKTvz9aGdWzH05QfVJwzZ9MjeWJ7idtgSKTjDntOYpr7hSJH5Oxe/dY8U3kx8fiMkAznuZBTxYhEl0T5dXvXBdZzAAT3V51YvR3PcpE+yu7wmVCVZdH9m+07+Fgtuu0/a6P9xrV4ZLpUcbxjnbMZXRDenH9b1HbiyKSxIh/FVx/vHjLuZDXvbp4214xb2npTyv5mPxc4Jxr6CSdfI4iLtrS78m2l9kTJ8Z8a574/kbuniZMUL+A7jEhWh03/9rAAAAAElFTkSuQmCC"
              >
            </label>
            <label>
              <input
                v-model="actions"
                type="radio"
                name="actions"
                value="move"
              >
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgBAMAAAB54XoeAAAAHlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC3KG9qAAAACnRSTlMA/u4sDXdPocXZFvB9nQAABIlJREFUeJztmrtP3EAQh60cGCj3IsJdxyMioYM7FInOIgXQ5aSAUpogoZSgJKI9pDw7LiQS/Lc5v3Z27Zl9TpEiU529u5/HuzO/WfucJP/tv/0j9oYbuMYNFFfcwEHGDBRfuIHDXWaguOcG9lldnAPFNjewnzMDxTNuoGBMwAq4yg1kTMAayKcRNZAvARsgm0Y0QLYElEAujRDcLgKQSSMAyKQRClDk3ECWBFSBLBqhATkSUANyaIQOZEhAHcigES3gIDq6W8D4BGwDozWiDRRb3MDYIt0BxhbpLjAyARFgnEYgwLgExIBRGoEBoxIQBcZoBAqMcREHRiQgDozQCAIYXqQJYHiRpoDBRZoEhiYgCQzVCBoYmIA0MFAjDMC1jBkYloAmYJBGmIBBCWgEhmiEERhSpM3AgCJtBgYUaQvQPwFtQG+NsAG9E9AK9NUIK9DXRTvQMwHtQE+NcAD6JaAD0E8jXIBeRdoF6FWknYA+RdoN6JGAbkAPjXAEurvoCHRPQFegs0a4Ap0T0BnoqhHOwHYCHhPp4w7UNWLhliix7kC9SJ9QGe4BVIt0b0ZluCPr4fvN6aXi0oGgdgEW0s6Pm9Ozi/32qMJBYhdAgR5uPp9djjP0rioHBS5CBNAsBpWDuIsE8LkROGq6IS4SQKO69DYM3Qjg0MlBbGoIoEn0wUHMRQo4pYHv1X4dFyngU9rBn4+/NqtOmzuP38zA7dvml01Qiz5kg7T+7rn8nXEA75MVenICgHPFW5QH6wzAedlYMMWsL7CsGtfS3XhgWXr35GEeC6wCZVkeT2OB1bKm8pgObTdgswgz3WPNegRQOQ/AvD4xkWeyDvADAVy80hsKkyXssDUHqoMvKeCq3iDUbfSSBK63gaOhPg6AysXrwbDP6HVmVbZsUMAlpbpUY9VthhScdmiPBA2EqK3Gqns1EJw8UW0u1H0auKU26Fs1EJypBpzXYgq4rCxCOVLb74LgaKFd1GIKuKKsQjeEQXC08wcaogts7hIJuOsG2M90B0ngE2UdkPDYw0L7RNhsTQLzFhAE5w7mYWYF1iuB7BtBcCBcj+28+k6xna30ZiBP3RpA+j1jT9cT2UfOxojmSJuWPbHnfxAcGaDqfoawYVb2xB6QQHAgtO0u1smXIUAQHAjt1OpijpAak0ughHapGdBFOyoC21jHQXAgtFMDsEg94/MvCA6EdnEVgzgMEpOB4Cj7/NQoX7+NQBAc9cLnBsW2vdq5li4qHVMD0PZqdU8C1bmeuFQ93EBwVNVeJIHWNxIgOFp4vaOAUxsQBEdV7SQlgD21E24TJLQ108PcbiA4d3gHXyAIDhEQvkAQHCKnfIGK5tMvP7yAIDi4jHgDQXDwvbY3EAQHV05vIAiOFtrhQEVwWqHduxyP97OiYeH1+NWFM1AKzov2MkMWCZ/3+o3g/MnaLanC8/h3shrW/4g0KTXa57+R2bz/8C3W0pNR7/UH0wSZvtqOiPUy26H4mhku5u1gsoRNX231BOdeQKOV6xL7NZJqxbrwfnd9xP3ZdTLh/nY9/dQ59RekakVzGMynzAAAAABJRU5ErkJggg=="
              >
            </label>
            <label>
              <input
                v-model="actions"
                type="radio"
                name="actions"
                value="shape"
              >
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgBAMAAAB54XoeAAAAHlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC3KG9qAAAACnRSTlP/AAaP9yvWlf28D3KXXQAAAI5JREFUeJzt2qENAgEAQ9EmXAjIw6BRWAz+FAucQSJYACbA4BmZsAJUkfcG+Au0GcsiKCgoKCgo+ENwvqbkdPwE949WL1ndx2xevV6y3mXb7CW3nLvBZw7d4CKXbnCZqRscujkAAAAAAAAA/tbUzQ39Sb0++tdvCfXjRP3aUT+f9O8x/QOPoKCgoKCg4HfePOIKnncZ9gYAAAAASUVORK5CYII="
              >
            </label>
            <label>
              <input
                v-model="actions"
                type="radio"
                name="actions"
                value="text"
              >
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgBAMAAAB54XoeAAAAHlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC3KG9qAAAACnRSTlMA/wxi9s87IauL8Nu1UwAAAXpJREFUeJzt2j1LxEAQBuAh4XKmjOZAu3gc1p4IahltLP0AP7rgB1raaH0H/gBB/L+Ch0pmdrNjZsEr3red2SfJ7qbaJUKQJUkRKQABxgPLq/eHsfdhP4Xk5eBVBV7fdG76VvH2NAge7wT+onZ1+BEAzyvmBUCi/U7wgreHQXrsAI+kFwbp3guOml4g7frAS0ezBsxqNziqeoL07AbPXL0qcFi7wPKpN0h3LnDN2aoDUxc4M4A0l6Dni5XgRILr7k4lmEvQM4VKMKkFeGgCF5PYGnRiA6cCnNnAiQC3beAgNpgLsLGBqQA9+1oLZgKsbGDSUesF6gMQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIMDYYMLBatnAIQd9Z6jaZLHBlINNbNB3sK1NHhsccPDNCG5y0Hd9QZspB1eN4JyDvisgynzf9fmN+yKSOivcs66KmMKi2LB4YlsbX3FLLMnXLO6Nw0PbWQwsxYLw/BEMByBABPm/fAJPo/BYXTJS5AAAAABJRU5ErkJggg=="
              >
            </label>
            <label>
              <input
                v-model="actions"
                type="radio"
                name="actions"
                value="select"
              >
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgAQMAAACxAfVuAAAABlBMVEUAAAAAAAClZ7nPAAAAAnRSTlMA/iyWEiMAAAA9SURBVHicY2AYBVQF/0EASsO5g1EQi9NHBckXHAUjEwzCpDgqSAfBUTAywSBMiqOC9BAchE04bIKjgKoAACuiXrD5nX1PAAAAAElFTkSuQmCC"
              >
            </label>
            <label>
              <input
                v-model="actions"
                type="radio"
                name="actions"
                value="fill"
              >
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgBAMAAAB54XoeAAAAElBMVEUAAAAAAAAAAAAAAAAAAAAAAADgKxmiAAAABnRSTlMA/rpXGges1xAeAAAFOElEQVR4nO2azWKjOgyFNYHsC2n3gXT2cTLd05l795227/8sF4ItS7IMtsPdRZv8wUGfdSI7JgCPeMQj/pf4tbHert1Wr+6a86aCl6Y5bKlXNWMM2+mNwGMctxO8THobMt+Ax9iqLDPwGM8bCV6sXrORFR3wVsz7zgtuUpbfXq9ph/x8/lwv/RjXq20GBDjfivW1p+n0bxw4l7m6NCLOHDivLHUg17xK4Pm9tPjqAr32AwDfbY19TNSTZAHwOe/rF+IK4BMmm1QWTW8CNvhiAHj3T0t4BTD4dI+TH/rTNS6s6o2MVUdeAOZ7sPRtbBqswvrOYAx4jB2my64jY6/phcBj1PblK15KVVwHxrpanRY+xaUYsKanAZNjzzV+9hEImkaJ8cKYBG0waEWjfDjHp9SywHUIDMSKlfZptCIRYKBWxK/CwAXVBBnwT3Y8MiOBKIuWYBQYqBWdCY7q52nAQK3o+iefqk2otwQMxIoOjyFoHlwCZsw2W3aIUpJFYPC2OLh0mKBCfKZ5B8BAu+J7MIZ1qHdYBgZqxc4+huPBgS/0hRKOuWoCwfdA8LgGDH7gDY5RfAjXgYOBou1mvwwcnS5ZHvSygQt/JgCDGPrn2AfzxfarwCA6FOX4S97vu1RgYMVkHRvHoj2NWt9vFHhxSUTGioG4zDGbJGB6pmheQYvE+W8RmFqLEe9lNhJ4XBz/Cic1gD8+QdYMyVJFBb69bvsrX3B8sUXzWRMcIsDY29ppBT9HT9WkoLVhK/SxwqZZj4Mi6N4z8iB1ySOCNaQf7Pywwgl6avOaC+VXRmjpJEHKbOa3XnTgNGRWFqvxxIDJAUYVkPGqCirAkVUKxsme3qqCmAz9VVMvMI/LazJBB4IaMNyW+rH0BjZB80F/0oFtltdQtD2dqUu8FVHQA2utAL6n38/24L4/Yb+QvcALYoJLTWv/zxj8LcmMgq6cufsJnyIPFHQTbe4eClkrckEcxNw9FMMT8YJueHOZhRW9oHuqVzkeworGCzpnHzNT5FYkgqXM3IpW8IU8z97CZMxW5NZg3fDGV0h6MCtSQTe8pVa8JcKmgHd6qYwwhPkHFXTDm7uF6cZq8M+f2aVyreiYj4HgjnySE8QrXLCWzSgx/vrTKj5qhVYkCxoh6MqSaUV32geuD7GuhVYkfuu4oGzAidFFBZ0DMq1IdgqMOL/MisYLyt+7ZVYkgjtJWGRFK/ikCbrGPRQKVlKwyIoEeR8U1ZWlUHAeM+33aY4V6QaTkYKucedYkQrugpPdvJhuRbZdXgWCwRItWXCYXtwIXzSAdCt+sjoaayAfdI5ICm6MXSDoGneqFUUZq3C4Mq0oB90E+1GZ9xiNOLzqg4V/lhXrhDb/O8eKKctzOnWnJrh8sEm3ots3WsZJtyLuKiwP+D7Vin4bZcUSrixrgvibc210Eq2IwCv7UMDXttHwwOv3It0CaLF2ycDg7XVcOMbvG6V8SROs6L7EaTdf5bZYGH7fKG22WLNilWpBF7yxh5EHDL5DRK6fCwwrVswGBiyLnkE28BQLViwA9mcpViwBhiUrIrB+MzgaJmJFv9eb+bNQ7Pm6qMuAwbcncV4pMODSjpfFAw/ZgtqKuxx4ChPmcgcw+Pn0gIprd+hWAvnc6f7/GiXAwG4J/QvfV7/JWwQMkT8YFANPEdl4LgSG2N74HX/VUm7v3gMM+v2A3A03FkpZ7vxvWpDiXcBaincBKyne/2c8fhPkXuApvqheuaVJ+Lst7dsWeqNit62e/dff7Sb0ZrGX91Ie8YhN4j9O2k4kglwzIwAAAABJRU5ErkJggg=="
              >
            </label>
          </div>
          <div class="globalcolor-case">
            <div
              class="color-one"
              :style="{ background: globalcolorone }"
            />
          </div>
        </div>
        <div
          id="canvas-helper"
          ref="canvashelper"
          class="canvas-helper-wrapper"
        >
          <div
            v-show="boundingbox_visbile"
            id="boundingbox"
            ref="boundingboxref"
            :style="{ width: boundingboxScale.width + 'px', height: boundingboxScale.height + 'px', top: boundingboxScale.top + 'px', left: boundingboxScale.left + 'px', transform: 'translateX('+ canvastranslate.x +'px) translateY('+ canvastranslate.y +'px) rotateZ(' + boundingbox_rotate + 'deg)'}"
          >
            <div
              id="tl-control"
              class="control"
              @mousedown="start_scaleboundingbox('nw')"
            />
            <div
              id="tr-control"
              class="control"
              @mousedown="start_scaleboundingbox('ne')"
            />
            <div
              id="bl-control"
              class="control"
              @mousedown="start_scaleboundingbox('sw')"
            />
            <div
              id="br-control"
              class="control"
              @mousedown="start_scaleboundingbox('se')"
            />
            <div
              id="east-control"
              class="control"
              @mousedown="start_scaleboundingbox('east')"
            />
            <div
              id="west-control"
              class="control"
              @mousedown="start_scaleboundingbox('west')"
            />
            <div
              id="south-control"
              class="control"
              @mousedown="start_scaleboundingbox('south')"
            />
            <div
              id="north-control"
              class="control"
              @mousedown="start_scaleboundingbox('north')"
            />
            <div
              id="rotate-control"
              @mousedown="start_rotateboundingbox()"
            />
          </div>
          <div
            v-show="addtext"
            id="texttool-position"
            :style="{ left: texttoolScale.left + 'px', top: texttoolScale.top + 'px', transform: 'translateX('+ canvastranslate.x +'px) translateY('+ canvastranslate.y +'px) scale('+ zoomscale +')'}"
          >
            <span
              id="texttool"
              ref="texttoolref"
              contentEditable="true"
              :style="{ color: texttoolColor, font: activefontweight + texttoolSize + 'px / ' + texttoolSize + 'px ' + fontfamily, 'z-index': '10'}"
              @input="texttoolchange"
            />
            <span
              v-show="textHasStroke"
              class="texttoolcopybox"
              :style="{ color: texttoolColor, font: activefontweight + texttoolSize + 'px / ' + texttoolSize + 'px ' + fontfamily, 'text-stroke': texttoolStroke + 'px '+ textstrokeColor, 'paint-order': 'stroke', 'z-index': '5'}"
              v-html="texttoolcopy"
            />
          </div>
          <div
            v-show="brushcursorvisible"
            id="custom-cursor"
            :style="{left: cursorpos.left + 'px', top: cursorpos.top + 'px', width: cursorsize + 'px', height: cursorsize + 'px', transform: 'translateX('+ canvastranslate.x +'px) translateY('+ canvastranslate.y +'px) scale('+ zoomscale +')', margin: '' + cursorpos.marginfix + 'px 0px 0px ' + cursorpos.marginfix + 'px'}"
          />
          <div
            v-show="selecttoolactive"
            id="selecttool"
            :style="{left: selectpos.left + 'px', top: selectpos.top + 'px', width: selectpos.width + 'px', height: selectpos.height + 'px', transform: 'translateX('+ canvastranslate.x +'px) translateY('+ canvastranslate.y +'px)'}"
          />
          <div
            class="dc-drawing-canvas"
            :width="mainCanvas_w"
            :height="mainCanvas_h"
            :style="{transform: 'translateX('+ canvastranslate.x +'px) translateY('+ canvastranslate.y +'px) scale('+ zoomscale +')'}"
            @mousemove="handleMouseMove"
            @mousedown="handleMouseDown"
            @mouseup="handleMouseUp"
            @mouseleave="handleMouseLeave"
          >
            <canvas
              id="canvasmask"
              :width="mainCanvas_w + 'px'"
              :height="mainCanvas_h + 'px'"
            />
            <canvas
              v-for="(canvas, index) in layers"
              v-show="canvas.visible"
              :id="'canvas_' + index"
              :key="canvas.id"
              ref="layers"
              :index="index"
              :width="mainCanvas_w + 'px'"
              :height="mainCanvas_h + 'px'"
            />
            <canvas
              id="dc-temp-canvas"
              :width="mainCanvas_w + 'px'"
              :height="mainCanvas_h + 'px'"
            />
            <canvas
              id="resulttempcanvas"
              style="display:none"
              :width="frameCanvas_w + 'px'"
              :height="frameCanvas_h + 'px'"
            />
            <div
              class="canvas-frame-background"
              :style="{ width: mainCanvas_w + 'px', height: mainCanvas_h + 'px'}"
            />
          </div>
          <div
            class="canvas-background"
            :style="{ width: mainCanvas_w + 'px', height: mainCanvas_h + 'px'}"
          />
        </div>
        <div
          class="resolution-box"
          style="display:none"
        >
          {{ frameCanvas_w }} x {{ frameCanvas_h }}
        </div>
        <div class="dc-options-right">
          <div class="dc-navigator-view">
            <div class="box-headline">
              Zoom
            </div>
            <div class="navigator-wrapper">
              <input
                v-model="zoompercent"
                class="inp_range"
                type="range"
                min="1"
                max="300"
                step="1"
              >
              <input
                v-model="zoompercent"
                class="inp_number"
                type="number"
                min="1"
                max="300"
              > %
            </div>
          </div>
          <div class="dc-layers-view">
            <div class="box-headline">
              Layers
            </div>
            <div class="layers-wrapper">
              <ul>
                <li
                  v-for="(layer, index) in layers"
                  v-show="!layer.deleted"
                  :key="index"
                  @click="setactivelayer(index, true)"
                >
                  <div
                    v-if="index == activelayer"
                    class="active"
                  >
                    <span
                      class="eye"
                      :class="{ 'eye-hidden': !layer.visible }"
                      @click="hidelayer(index)"
                    />
                    <span
                      v-if="layer.id != 0"
                      class="layer-name"
                    >
                      <span v-if="layer.typ == 'shape'">{{ layer.name }}</span>
                      <span v-if="layer.typ == 'normal'">{{ layer.name }}</span>
                      <span v-if="layer.typ == 'image'">{{ layer.name }}</span>
                      <span v-if="layer.typ == 'duplicate'">{{ layer.name }} copy</span>
                      <span v-if="layer.typ == 'text'">{{ layer.name }}</span>
                    </span>
                    <span
                      v-if="layer.id == 0"
                      class="layer-name"
                    >Main Layer</span>
                    <span
                      v-if="index == 0"
                      class="locked"
                    />
                  </div>
                  <div v-else>
                    <div
                      class="eye"
                      :class="{ 'eye-hidden': !layer.visible }"
                    />
                    <div
                      v-if="layer.id != 0"
                      class="layer-name"
                    >
                      <span v-if="layer.typ == 'shape'">{{ layer.name }}</span>
                      <span v-if="layer.typ == 'normal'">{{ layer.name }}</span>
                      <span v-if="layer.typ == 'image'">{{ layer.name }}</span>
                      <span v-if="layer.typ == 'duplicate'">{{ layer.name }} copy</span>
                      <span v-if="layer.typ == 'text'">{{ layer.name }}</span>
                    </div>
                    <div
                      v-if="layer.id == 0"
                      class="layer-name"
                    >
                      Main Layer
                    </div>
                    <span
                      v-if="index == 0"
                      class="locked"
                    />
                  </div>
                </li>
              </ul>
            </div>
            <div class="layer-options">
              <div class="btn-left">
                <button @click="movelayer('up')">
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAZxJREFUWEft1l1LFVEUxvGf6U1dRkQhWhFGpV/Fi0BFKku0CKGPE0RiouULJuJFX6U3FKkQJaK67aYyFuxjw3iO58wc49zMvpzZM8//efZaa6ZLh1dXh/VVAFUCVQLtJnA2tfGPsu3cDsBN3ErCm3hXBqIswHU8wlgSfYVn+FAUogzANTxI4r1JcA8BMYetIhBFAa5iCuPoR08S+4VdrGIeO61CFAG4gvu4g8sZ8ZpWQHzCMhbxsRWIVgEu4S4mECnUnOc1AiLcL+ElPjeDaAWgL7m+h4FjxLNJbONFSiOOpuFqBhBFdhuTiOJr5LxeElGMC1hBFGnddRzAxVRs04i2624WZ+7+79SWz7GG/XrPNwK4kNrsIW6UEK9pBcT71J4B8SUPUQ/gfBKPQdOOeBYipuRsmhVfsxB5gHMYxQwGcapg7I22/8FbPMU6vtU2ZgHiwzKCxxjixH/XDvAGT7CB7wGRBwjnw/h5Qs7zrzmD1ymJIwCxOc48plxRgHCXNxTX8kd8Og2nwy9nsznwn4L499oKoEqgSqDjCfwFLfFFIVxq2rcAAAAASUVORK5CYII="
                    alt=""
                  >
                </button>
                <button @click="movelayer('down')">
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAdxJREFUWEft1deKFFEYBOBvjQ+gXohZMWB6Dr0yYcKE4GMJYsKI4UqfQ8yiiAFB9AHMUstpaJqdPdMzK+vFHGimme5zqv76q/6eMs9rap7xTQhMFPjvFFiAXH3Xn7JhmIJ+I9f0am9YiG1Yh+9oDu1LZtD7wVqCd3iGX20CebgCp7G3gP8LAlH3AS7hc3AaBfK7HPtwDruxeK5KL+f8wCOcx318aRPIO2G3EvtxFruKZHPB4xse4wLu4VPjg65pQmIVDpR27MTSMRk04JH9Lj4OMmGDEzOuLiROYccYJAL+BJcL+IfGfDOloF1oSKzBQZzE9hFIBPwpruAO3nfBuzHsKh0Sa3EYx0tE045a1pOegD/HNdwq0ZuOXXfVDguJ9YXEMWwtSgza14C/wPUC/namymst6LZjI47gKLaUdHRJBDwD7CVu4gbezAZea0GbxCJsKq1IS3KfqdYmEdlfl6ojfe5/1hJUa0GXxGacwCFsaM2JVB6pb+MqXg0D3keBhkiUyPciyUhCYtKszPc4PY6P+aqV9/FAV8WQSCzPlNGd5xmtF0vshgYfRYG2EhlQe8ofD8vA6QU+DoHsTUSXFQJfa24fZMY+Jpxtjoz86R6XQC1l1ecTAhMFJgr8BSskXCH7NY3cAAAAAElFTkSuQmCC"
                    alt=""
                  >
                </button>
              </div>
              <div class="btn-right">
                <button @click="duplicatelayer()">
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAYAAAA5ZDbSAAAAAXNSR0IArs4c6QAAA6FJREFUeF7tnUt24jAQRZ/nwA5YALD/pTQsgB0Ac/pUQ/oYYhyMKi59ricexC59rq5VwRJ04qi6B7qqW0fjBODKBwGAGwRs0BdSk3ZfJV0k2bmKY8jgpaQ/klZVtHBaI06SdpLO027L9+ohwAb22DDgtSQDXcUB4EeMBhbAVQzt4Ua0CbjrOi0WC9m5luN6vepyucjOvaNNwMvlUvv9XqtVPXnX6XTSdrvV+fyQT7UJ2MAej8fqAK/Xaxno5g0GcLkT01tZNIABXFwP2KOZR/QdGwYXN37/V5hHNEmW/mXPZNFlWozBGIzBZbp7qzUGYzAGY3CBPcD/wb0VHWTRBY7ge5WZg5mDmYPL9ZcsmteFNnqZg8t1mDmYORiDy/W3kjn4xQK6US62Fmuz2TyvybIFWpvCFr6P7sao4hFtsHa73XPCNArYBoXd97Sq0jrLIJe0dWV0N0YVgF98KlXyk3VK3UdXggJ4SlfmeS2A8+TiVqs2AbMbo6L3wUNzMLsxKgfMp28AdpsE5wr0yTvsarNoDMbgucRzKweDey8OMBiD3cyaKxAGY/C3sUaSNZd+DuVgMAZjsINIYSEwGIMxOEw/h4IxGIMx2EGksBAYjMEYHKafQ8EYjMEY7CBSWAgMxmAMDtPPoWAMxmAMdhApLAQGYzAGh+nnUDAGYzAGO4gUFgKDMRiDw/RzKBiDMRiDHUQKC4HBGIzBYfo5FIzBGIzBDiKFhcBgDMbgMP0cCsZgDMZgB5HCQmAwBmNwmH4OBWMwBmOwg0hhITAYgzE4TD+HgjEYgzHYQaSwEL9msH017+FwkJ1zPIZ+YINvuruReut7suzLtXOFa40Y+tUVAE8AnKO1P9UJwAD+aYxk9/dfm4Oza+kbFcLg1wZbJnWQlGdGNQzXcolFP6cA8GvA1lkGdygBe8OdkEusvvv+oATwa8AhhBILXUk62i/hfsUBMIATx9T8t3slWfPXPL1EDJbsF9C+HSXNs2PDAMAATn9MREfgEU2SxSM62sKU8jEYgzE4xaDoezEYgzE42sKU8jEYgzE4xaDoezEYgzE42sKU8jEYgzE4xaDoezEYgzE42sKU8jG4Z3DuuzE+AT20g0O398Dr+7kdg3PfjfEJYLvHINtOjt7RJuBPO7DA+wBcILQpVQbwlN4q8NomAJe4G8NrLJ0lbWx6HgpYy6rKEndjeAG2jMvgPmReX8FrAezVWdXFAXB1SB8bBGAAV94DlTfvL6h4vdPMnZcYAAAAAElFTkSuQmCC"
                    alt=""
                  >
                </button>
                <button @click="addlayer()">
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4AgMAAABECt5BAAAADFBMVEUAAAAAAAAAAAAAAAA16TeWAAAAA3RSTlMAgH8BTzA4AAAApUlEQVRIx+3UoRHDMBAFUQupDJWalJoygnJBmQ1Yfeyx77ObB5bdUXFX5mO75ubm5ubm8/P/7sOPqtfvFF5V78Cz6hN4VNVzz8SViSsTVyauTFyZuDJxZeLKxJWJKxNXJq5MXJm4MnFl4srElYkrE1cmrkxcmbgycWfiysSViSsTdyauTFyZuDJxZeLCxDOvzDPz2DBxJm9wZZ6ZhzPxzCvzFM7xL3aB/p8IYvJLAAAAAElFTkSuQmCC"
                    alt=""
                  >
                </button>
                <button @click="deletelayer()">
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4AgMAAABECt5BAAAAAXNSR0IB2cksfwAAAAxQTFRFAAAAAAAAAAAAAAAANek3lgAAAAR0Uk5T/gB8KGMVmQ4AAAJFSURBVHicpdexTuNAEAbgyVopHOQyj+DmELrKvR+BgiUUEfgRKNEVwS+RPiUCIaqUSHkJ95SIHgldcbnd2fHasXc8wUyXfMnu2P5t74L2dfOxAVOzp8/mO/D4AL5Oqy7/gXap10N+h049t7mntSPf9RVgW/N1SEFVxCV9ftzv9f3eHZ6pxLEbelY3q/Vq44cHvcA/v+h2/UWOLV/Zcbf6sFboa8M7o5+6W9dudljUx9Ap21GkYela7NebHR1uAaog25ZTyG2DwTLDJ1BCxrDpKsL2mSpAATe1qSUePMuXdG74yU1xrSGXzFnBwZVhxbemwFyRlOHCHHdOsQlOPbEMJ0F+s1zY5s8Caq9o7Bh+9xRvm9heUFvNbeXmdTdGUjOol+YHNx91luG8Cf6vp72pf48b/80UroK3yHGcwvIHnMHFEM8lvhzitcSLIa5A/4DN/V2OZuWeDlxFMuc8T2QueI5lvuXZPNf0+Wie0jOVqVTmgSxmMg9kcW54IGwC27fBQBYFruyLimd9BJecqmN4x3GEnI/kCXIxkvENzGdR4ASZzeIUmQ2bwCkyGzaBM2Q2iwLPkdksCrxGZrPomA1bNcz6YEH2TVbEu1EcEeejeEJchDk+jpks0kKUy6LAU2ImiwKnxEwWBc6ImSzOiZmwCbwmZrIocEXMZFFgXXMZUuV5F+LIc/CCJ56DZzXzHJrcLW7Bryo7ddbiRe/vtLSl/Vhv17TVbe4OX69r/V7wq61+VetZr/z8qtlcNWz2URuLs/bm6j+BMbUibx6xWgAAAABJRU5ErkJggg=="
                    alt=""
                  >
                </button>
              </div>
            </div>
          </div>
          <div
            class="dc-history-view"
            style="margin-top:20px;"
          >
            <div class="box-headline">
              History
            </div>
            <div
              id="history"
              class="history-wrapper"
            >
              <ul>
                <li
                  v-for="(step, index) in historyArray"
                  :key="index"
                >
                  <div
                    class="step"
                    :class="{ 'active': index === historyStep }"
                    @click="domultiselect(index)"
                  >
                    <span :class="{ 'past': index < historyStep + 1 }">{{ step.typ }}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a-modal
      v-model="modalcanvassize"
      title="Canvas Size"
      width="300px"
      @ok="resizeFrameCanvas"
      @cancel="handleCancel('CanvasSize')"
    >
      <a-form
        :label-col="{ span: 8, offset: 0 }"
        :wrapper-col="{ span: 16, offset: 0 }"
      >
        <a-form-item
          label="Width"
          style="margin-bottom:0px;"
        >
          <a-input
            v-model="newframe_w"
            type="number"
            addon-after="Pixel"
          />
        </a-form-item>
        <a-form-item
          label="Height"
          style="margin-bottom:0px;"
        >
          <a-input
            v-model="newframe_h"
            type="number"
            addon-after="Pixel"
          />
        </a-form-item>
      </a-form>
      <p style="text-align:right;margin:0px 2px 0px 0px; padding:0px;">
        <small>Acitive Size: {{ frameCanvas_w }} x {{ frameCanvas_h }} px</small>
      </p>
    </a-modal>
    <a-modal
      v-model="modalimageimport"
      title="Import Image"
      :ok-button-props="{ props: { disabled: !imageimportfile } }"
      width="70%"
      @ok="doImportImage"
      @cancel="handleCancel('ImageImport')"
    >
      <a-tabs ref="importimagetab">
        <a-tab-pane
          key="1"
          tab="Computer"
        >
          <a-form
            :label-col="{ span: 8, offset: 0 }"
            :wrapper-col="{ span: 16, offset: 0 }"
          >
            <a-form-item style="margin-bottom:5px;">
              <h3>Select an image file to import</h3>
              <input
                id="ImageImport"
                ref="RefImageImport"
                type="file"
                name="ImageImport"
                accept="image/png, image/jpeg, image/gif"
                @change="ImportImage"
              >
            </a-form-item>
            <a-form-item style="margin-bottom:0px;">
              <a-checkbox v-model="scaleimport">
                Scale Image to Canvas Size
              </a-checkbox>
            </a-form-item>
          </a-form>
        </a-tab-pane>
        <a-tab-pane
          key="2"
          tab="Media Manager"
        >
          <div class="modalmediamanger">
            <MediaManager
              v-model="importImageFile"
              :module="filesModule"
              :grid-view="false"
              :with-upload="false"
              @change="ImportImageMedia"
            />
          </div>
          <br>
          <a-checkbox v-model="scaleimport">
            Scale Image to Canvas Size
          </a-checkbox>
        </a-tab-pane>
      </a-tabs>
    </a-modal>
    <!-- <a-modal v-model="modalimageimport" title="Import Image" :ok-button-props="{ props: { disabled: !imageimportfile } }" width="70%" @ok="doImportImage">
          <div class="uploadimage">
             <a-form :label-col="{ span: 8, offset: 0 }" :wrapper-col="{ span: 16, offset: 0 }">
            <a-form-item style="margin-bottom:5px;">
              <h3>Select an image file to import</h3>
              <input type="file" id="ImageImport" name="ImageImport" accept="image/png, image/jpeg, image/gif" ref="RefImageImport" @change="ImportImage"/>
            </a-form-item>
            <a-form-item style="margin-bottom:0px;">
              <a-checkbox v-model="scaleimport">Scale Image to Canvas Size</a-checkbox>
            </a-form-item>
          </a-form>
          </div>
          <div class="modalmediamanger">
            <MediaManager :module="filesModule" :gridView="false" v-model="importImageFile" :withUpload="false"></MediaManager>
          </div>
    </a-modal> -->
    <a-modal
      v-model="modalopenfile"
      :destroy-on-close="true"
      title="Open File"
      width="70%"
      @ok="openBSDfromMedia"
    >
      <div
        ref="fileopenuploader"
        class="uploadimage"
      >
        <a-upload-dragger
          name="file"
          :multiple="false"
          accept=".bsd"
          @change="importBSDFile"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox"/>
          </p>
          <p class="ant-upload-text">
            Click or drag file to this area to upload
          </p>
        </a-upload-dragger>
      </div>
      <div class="modalmediamanger">
        <MediaManager
          v-model="mediaimage"
          :module="filesModule"
          :grid-view="false"
          :with-upload="false"
        />
      </div>
    </a-modal>
    <a-modal
      v-model="modalsaveproject"
      title="Save Project"
      :ok-button-props="{ style: { display: 'none' } }"
      width="400px"
    >
      <a-form
        :label-col="{ span: 5, offset: 0 }"
        :wrapper-col="{ span: 16, offset: 0 }"
      >
        <a-form-item
          style="margin-bottom:5px;"
          label="Filename:"
        >
          <a-input
            v-model="projectname"
            type="text"
            addon-after=".bsd"
          />
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button
          type="primary"
          style="float:left;"
          @click="uploadbsd"
        >
          <a-icon type="upload"/>
          Upload
        </a-button>
        <a-button
          type="primary"
          style="float:left;"
          @click="downloadbsd"
        >
          <a-icon type="download"/>
          Download
        </a-button>
        <a-button
          key="back"
          @click="modalsaveproject = false"
        >
          Cancel
        </a-button>
      </template>
    </a-modal>
    <a-modal
      v-model="modalsaveimage"
      :visible="true"
      class="modalimageexport"
      title="Save Image As"
      :width="modalsavewidth"
      :style="{ 'max-width': '800px'}"
      :ok-button-props="{ style: { display: 'none' } }"
    >
      <div class="export-container">
        <div class="left">
          <div
            id="exportimage-preview"
            :width="frameCanvas_w + 'px'"
            :height="frameCanvas_h + 'px'"
          >
            <div class="export-result-wrapper">
              <canvas
                id="result-canvas"
                :width="frameCanvas_w + 'px'"
                :height="frameCanvas_h + 'px'"
                style="display:none;"
              />
              <img id="result-imageY">
            </div>
          </div>
        </div>
        <div class="right">
          <a-form
            :label-col="{ span: 7, offset: 0 }"
            :wrapper-col="{ span: 16, offset: 0 }"
          >
            <a-form-item
              style="margin-bottom:5px;"
              label="Filename:"
            >
              <a-input
                v-model="filename"
                type="text"
              >
                <a-select
                  slot="addonAfter"
                  v-model="exportfileformat"
                  default-value=".png"
                  style="width: 80px"
                >
                  <a-select-option value="jpg">
                    .jpg
                  </a-select-option>
                  <a-select-option value="png">
                    .png
                  </a-select-option>
                </a-select>
              </a-input>
            </a-form-item>
            <a-form-item
              style="margin-bottom:5px;"
              label="Width:"
            >
              <a-input
                v-model="frameCanvas_w"
                type="number"
                addon-after="Pixel"
                disabled
              />
            </a-form-item>
            <a-form-item
              style="margin-bottom:5px;"
              label="Height:"
            >
              <a-input
                v-model="frameCanvas_h"
                type="number"
                addon-after="Pixel"
                disabled
              />
            </a-form-item>
            <a-form-item
              style="margin-bottom:5px;"
              label="Background:"
            >
              <a-dropdown :trigger="['click']">
                <a-input
                  v-model="exportimagebackground"
                  type="text"
                >
                  <span slot="addonAfter"><span
                    :style="{ background: exportimagebackground }"
                    class="current-color"
                  /></span>
                </a-input>
                <a-menu
                  slot="overlay"
                  style="padding:0px;"
                >
                  <colorpicker
                    mode="hex"
                    style="margin: 0 auto"
                    value="black"
                    @input="changeExportColor"
                  />
                </a-menu>
              </a-dropdown>
            </a-form-item>
          </a-form>
        </div>
      </div>
      <template slot="footer">
        <a-button
          type="primary"
          style="float:left;"
          :disabled="!enableexport"
          @click="uploadimage"
        >
          <a-icon type="upload"/>
          Upload
        </a-button>
        <a-button
          type="primary"
          style="float:left;"
          :disabled="!enableexport"
          @click="downloadimage"
        >
          <a-icon type="download"/>
          Download
        </a-button>
        <a-button
          key="back"
          @click="modalsaveimage = false"
        >
          Cancel
        </a-button>
      </template>
    </a-modal>
    <a-modal
      v-model="modalnewproject"
      title="New Project"
      width="300px"
      @ok="resizeFrameCanvas"
      @cancel="handleCancel('CanvasSize')"
    >
      <a-form
        :label-col="{ span: 8, offset: 0 }"
        :wrapper-col="{ span: 16, offset: 0 }"
      >
        <a-form-item
          label="Name"
          style="margin-bottom:0px;"
        >
          <a-input
            v-model="projectname"
            type="text"
          />
        </a-form-item>
        <a-form-item
          label="Width"
          style="margin-bottom:0px;"
        >
          <a-input
            v-model="projectwidth"
            type="number"
            addon-after="Pixel"
          />
        </a-form-item>
        <a-form-item
          label="Height"
          style="margin-bottom:0px;"
        >
          <a-input
            v-model="projectheight"
            type="number"
            addon-after="Pixel"
          />
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button
          key="back"
          @click="modalnewproject = false"
        >
          Cancel
        </a-button>
        <a-button
          type="primary"
          @click="createnewproject"
        >
          Create
        </a-button>
      </template>
    </a-modal>
    <div
      v-show="showstartscreen"
      class="startscreenmask"
    >
      <div id="startscreen">
        <h2>Zeichentool</h2>
        <a-button
          style="margin:20px"
          @click="modalnewproject = true"
        >
          <a-icon type="star"/>
          New Project
        </a-button>
        <a-button
          style="margin:20px"
          @click="modalopenfile = true"
        >
          <a-icon type="folder-open"/>
          Open Project
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import colors from 'vue-color'
import Api from '@/api'
import MediaManager from '@/components/MediaManager'
import Module from '@/module/module'

export default {
  name: 'CanvasDrawWidget',
  components: {
    'colorpicker': colors.Sketch,
    MediaManager,
  },
  props: {
    resource: {
      type: Object,
      required: false,
      default: null,
    },
    mode: {
      type: String,
      required: false,
      default: null,
    },
    config: {
      type: Object,
      default: () => {},
    },
    fonts: {
      type: Array,
      default: () => ['Arial', 'Verdana', 'Serif', 'Helvetica', 'Georgia', 'FreeMono', 'Roboto', 'Architects Daughter', 'Dancing Script', 'Open Sans'],
    },
  },
  data: () => ({
    vueCanvas: null,
    mainCanvas_h: 3000,
    mainCanvas_w: 3000,
    frameCanvas_h: 250,
    frameCanvas_w: 250,
    newframe_w: 250,
    newframe_h: 250,
    projectwidth: 400,
    projectheight: 300,
    canvashelper_w: 500,
    canvashelper_h: 500,
    historyLenght: 30,
    historyStep: -1,
    historyArray: [],
    layers: [{
      id: 0,
      visible: true,
      deleted: false,
      typ: 'normal',
      name: 'Main Layer',
    }],
    projectArray: [],
    shapeCount: 0,
    duplicateCount: 0,
    brushsize: 15,
    erasesize: 15,
    cursorleft: 0,
    cursortop: 0,
    brushcursorvisible: false,
    zoompercent: 100,
    zoomratio: 1,
    zoomratioexport: 1,
    showstartscreen: true,
    modalnewproject: false,
    modalcanvassize: false,
    modalimageimport: false,
    modalopenfile: false,
    modalsaveproject: false,
    modalsaveimage: false,
    modalsavewidth: '800px',
    mediaimage: null,
    importImageFile: null,
    addshape: false,
    rulerhr: false,
    rulervr: false,
    addtext: false,
    maxlayerid: 1,
    activelayer: 0,
    actions: '',
    isEditing: false,
    globalcolorone: '#000000',
    globalcolortwo: '#ffffff',
    activecolorcode: '#000000',
    texttoolColor: '#000000',
    paintbucketColor: '#000000',
    textstrokeColor: '#000000',
    texttoolSize: 24,
    texttoolStroke: 0,
    fontitalic: false,
    fontbold: false,
    fontfamily: 'Open Sans',
    texttoolcopy: '',
    mouse_x: 0,
    mouse_y: 0,
    down_y: 0,
    down_x: 0,
    canvas_x: 0,
    canvas_y: 0,
    texttool_x: 0,
    texttool_y: 0,
    texttool_start_x: 0,
    texttool_start_y: 0,
    selecttoolactive: false,
    selecttool_x: 0,
    selecttool_y: 0,
    selecttool_w: 0,
    selecttool_h: 0,
    boundingbox_y: 10,
    boundingbox_x: 10,
    boundingbox_w: 10,
    boundingbox_h: 10,
    boundingbox_rotate: 0,
    boundingbox_visbile: false,
    bb_scale: false,
    bb_rotate_angle: 0,
    scale_new_x: 0,
    scale_new_y: 0,
    scale_new_w: 0,
    scale_new_h: 0,
    scale_old_x: 0,
    scale_old_y: 0,
    scale_old_w: 0,
    scale_old_h: 0,
    scaling: false,
    isrotating: false,
    scale_direction: null,
    mousedownbeginX: 0,
    mousedownbeginY: 0,
    isdrawing: false,
    isMouseDown: false,
    isDragging: false,
    tempCanvas: null,
    maskCanvas: null,
    imageimportfile: false,
    scaleimport: false,
    enableexport: false,
    filename: 'filename',
    projectname: 'New Project',
    importfile: null,
    openfile: null,
    projectloaded: false,
    exportfileformat: 'png',
    exportimagebackground: '#ffffff',
    activeshape: 0,
    shapeFill: '#000000',
    shapeStroke: '#ff0000',
    shapeStrokeSize: 8,
    shapes: [{
      id: 0,
      name: 'rect',
      path: 'M0 0 20 0 20 20 0 20Z',
      width: 20,
      height: 20,
    },
      {
        id: 1,
        name: 'circle',
        path: 'M10 0A1 1 0 0010 20 1 1 0 0010 0',
        width: 20,
        height: 20,
      },
      {
        id: 2,
        name: 'rect-round',
        path: 'm5 0c-3 0-5 2-5 5l0 10c0 3 2 5 5 5l10 0c3 0 5-2 5-5l0-10c0-3-2-5-5-5z',
        width: 20,
        height: 20,
      },
      {
        id: 3,
        name: 'star',
        path: 'm27.564 32.5114-10.528-5.536-10.53 5.536 2.012-11.726-8.518-8.304 11.774-1.71 5.264-10.668 5.266 10.668 11.77 1.71-8.516 8.304z',
        width: 33,
        height: 32,
      },
      {
        id: 4,
        name: 'play',
        path: 'm0 0 0 20 15-10z',
        width: 15,
        height: 20,
      },
      {
        id: 5,
        name: 'halfcircle',
        path: 'M10 0A1 1 0 0010 20Z',
        width: 10,
        height: 20,
      },
      {
        id: 6,
        name: 'arrow',
        path: 'M0 9 15 9 10 4 14 0 25 12 14 24 10 20 15 15 0 15Z',
        width: 25,
        height: 24,
      },
      {
        id: 7,
        name: 'screwhead',
        path: 'm 0 0 l 12 0 l 12 12 l 0 36 l -12 12 l -12 0 l 0 -24 l 12 0 l 0 -12 l -12 0 z',
        width: 23,
        height: 60,
      },
      {
        id: 8,
        name: 'heart',
        path: 'm12 3.248c-3.148-5.402-12-3.825-12 2.944 0 4.661 5.571 9.427 12 15.808 6.43-6.381 12-11.147 12-15.808 0-6.792-8.875-8.306-12-2.944z',
        height: 22,
        width: 25,
      },
    ],
  }),
  computed: {
    identifier () {
      return this.config.identifier
    },
    filesModule () {
      return Module.byIdentifier('files')
    },
    textHasStroke () {
      if (parseInt(this.texttoolStroke) === 0) {
        return false
      } else {
        return true
      }
    },
    highestLayerID () {
      if (this.layers.length === 0) return
      return this.layers.reduce((a, b) => Number(a.id) > Number(b.id) ? a : b)
    },
    zoomscale () {
      return (this.zoomratio / 100) * this.zoompercent
    },
    boundingboxScale () {
      var ret = {}
      ret.width = this.boundingbox_w * this.zoomscale
      ret.height = this.boundingbox_h * this.zoomscale
      ret.top = this.boundingbox_y * (this.zoomscale)
      ret.left = this.boundingbox_x * (this.zoomscale)
      return ret
    },
    texttoolScale () {
      var ret = {}
      ret.left = this.texttool_x * (this.zoomscale)
      ret.top = this.texttool_y * (this.zoomscale)
      return ret
    },
    canvastranslate () {
      var ret = {}
      var canvaswidth = this.mainCanvas_w * this.zoomscale
      var canvasheight = this.mainCanvas_h * this.zoomscale

      if (canvaswidth < this.mainCanvas_w) {
        ret.x = (this.mainCanvas_w - canvaswidth) / 2
      } else {
        ret.x = 0
      }

      if (canvasheight < this.mainCanvas_h) {
        ret.y = (this.mainCanvas_h - canvasheight) / 2
      } else {
        ret.y = 0
      }
      return ret
    },
    activefontweight () {
      var ret = ''
      if (this.fontitalic) {
        ret = 'italic '
      }
      if (this.fontbold) {
        ret = ret + 'bold '
      }
      return ret
    },
    cursorsize () {
      var ret
      if (this.actions === 'drawing') {
        ret = this.brushsize
      } else {
        ret = this.erasesize
      }
      return ret
    },
    cursorpos () {
      var ret = {}
      ret.left = this.cursorleft * (this.zoomscale)
      ret.top = this.cursortop * (this.zoomscale)
      ret.marginfix = -this.cursorsize / 2
      return ret
    },
    selectpos () {
      var ret = {}
      ret.width = this.selecttool_w * this.zoomscale
      ret.height = this.selecttool_h * this.zoomscale
      ret.left = this.selecttool_x * (this.zoomscale)
      ret.top = this.selecttool_y * (this.zoomscale)
      return ret
    },
  },
  watch: {
    'zoompercent': function (val, oldVal) {
      this.scrolltoMid()
    },
    'exportfileformat': function (val, oldVal) {
      this.drawresultforexport(val)
    },
    'exportimagebackground': function (val, oldVal) {
      this.drawresultforexport(this.exportfileformat)
    },
    'actions': function (val, oldVal) {
      var canvashelper = document.getElementById('canvas-helper')
      this.brushcursorvisible = false
      canvashelper.style.cursor = 'auto'
      if (oldVal === 'text' && val !== 'text') {
        this.TextToolAction('draw')
        this.addtext = false
      }
      if (val === 'text') {
        this.selecttoolactive = false
      }
      if (val === 'move') {
        this.selecttoolactive = false
      }
      if (oldVal === 'move' && val !== 'move') {
        this.boundingbox_visbile = false
      }
      if (val === 'drawing' || val === 'erase') {
        this.brushcursorvisible = true
        canvashelper.style.cursor = 'none'
      }
      if (val === 'shape') {
        this.selecttoolactive = false
        canvashelper.style.cursor = 'crosshair'
      }
    },
    'shapeCount': function (val, oldVal) {
      this.shapeCount = this.highestArrayID('shape')
    },
    'projectloaded': function (val, oldVal) {
      if (val === true) {
        this.projectloaded = false
        this.historyArray.length = 0
        this.historyStep = -1
        this.historyPush('Open Project')
      }
    },
    'activelayer': function (val, oldVal) {
      this.$nextTick(function () {
        var c = document.getElementById('canvas_' + val)
        var ctx = c.getContext('2d')
        this.vueCanvas = ctx
      })
    },
  },
  beforeMount () {
    window.addEventListener('beforeunload', this.preventNav)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('beforeunload', this.preventNav)
    })
  },
  mounted () {
    var c = this.$refs.layers[this.activelayer]
    var ctx = c.getContext('2d')
    this.vueCanvas = ctx
    var tc = document.getElementById('dc-temp-canvas')
    this.tempCanvas = tc.getContext('2d')
    this.drawcanvasmask()
    this.historyPush('Open')
    document.addEventListener('keydown', this.keyupHandler)
    this.$refs.canvashelper.addEventListener('click', this.clickHandler)
    window.addEventListener('resize', this.resizeHanlder)
    this.$refs.canvashelper.addEventListener('mousewheel', this.scrollHandler)
    this.actions = 'drawing'
    this.canvashelper_w = document.getElementById('canvas-helper').offsetWidth
    this.canvashelper_h = document.getElementById('canvas-helper').offsetHeight
    this.scrolltoMid()
  },
  destroyed () {
    document.removeEventListener('keydown', this.keyupHandler)
  },
  methods: {
    clickHandler (event) {
    },
    resizeHanlder (event) {
      this.canvashelper_w = document.getElementById('canvas-helper').offsetWidth
      this.canvashelper_h = document.getElementById('canvas-helper').offsetHeight
      this.resetZoom()
      this.scrolltoMid()
    },
    scrollHandler (event) {
      if (event.altKey) {
        event.preventDefault()
        var delta
        if (event.wheelDelta) {
          delta = event.wheelDelta
        } else {
          delta = -1 * event.deltaY
        }
        if (delta < 0) {
          if ((this.zoompercent - 10) > 0) {
            this.zoompercent = this.zoompercent - 10
          } else {
            this.zoompercent = 1
          }
        } else {
          this.zoompercent = this.zoompercent + 10
        }
      }
    },
    preventNav (event) {
      if (!this.isEditing) return
      event.preventDefault()
      event.returnValue = ''
    },
    keyupHandler (event) {
      if (event.ctrlKey && event.shiftKey && event.code === 'KeyZ') {
        this.historyRedo()
      } else if (event.ctrlKey && event.code === 'KeyZ') {
        this.historyUndo()
      } else if (event.ctrlKey && event.code === 'Digit0') {
        this.resetZoom()
        this.scrolltoMid()
      } else if (event.ctrlKey && event.code === 'KeyA') {
        if (this.actions === 'select') {
          event.preventDefault()
          var left = (this.mainCanvas_w - this.frameCanvas_w) / 2
          var top = (this.mainCanvas_h - this.frameCanvas_h) / 2
          this.selecttoolactive = true
          this.selecttool_x = left
          this.selecttool_y = top
          this.selecttool_w = this.frameCanvas_w
          this.selecttool_h = this.frameCanvas_h
        }
      } else if (event.keyCode === 39) {
        if (this.actions === 'move') {
          // event.preventDefault()
          // this.movecanvascontentbykey('right')
        }
      } else if (event.keyCode === 27) {
        if (this.actions === 'text') {
          this.TextToolAction('cancel')
        }
      } else if (event.code === 'Delete') {
        if (this.selecttoolactive) {
          this.historyPush('Clear')
          this.clearRectangle(this.vueCanvas, this.selecttool_x, this.selecttool_y, this.selecttool_w, this.selecttool_h)
        }
      }
    },
    handleMouseDown (e) {
      this.mouse_x = parseInt(e.offsetX)
      this.mouse_y = parseInt(e.offsetY)
      this.isMouseDown = true
      this.isDrawing = true
      this.isDragging = true
      this.mousedownbeginX = parseInt(e.offsetX)
      this.mousedownbeginY = parseInt(e.offsetY)
      this.boundingbox_visbile = false
      this.down_x = parseInt(e.offsetX)
      this.down_y = parseInt(e.offsetY)
      if (this.actions === 'move') {
        // this.tempCanvas.drawImage(this.$refs.layers[this.activelayer], 0, 0, this.mainCanvas_w, this.mainCanvas_h)
      }
      if (this.actions === 'text') {
        e.preventDefault()
        this.createTextField()
      }
      if (this.actions === 'select') {
        this.selecttool_x = parseInt(e.offsetX)
        this.selecttool_y = parseInt(e.offsetY)
        this.selecttool_w = 0
        this.selecttool_h = 0
        this.selecttoolactive = true
      }
      if (this.actions === 'fill') {
        this.replacecol(e)
        this.historyPush('Paint Bucket Tool')
      }
    },
    handleMouseUp (e) {
      this.mouse_x = parseInt(e.offsetX)
      this.mouse_y = parseInt(e.offsetY)
      this.isDragging = false
      if (this.isDrawing) {
        if (this.actions === 'drawing') {
          if (this.rulervr) {
            this.drawLine(this.mousedownbeginX, this.y, this.mousedownbeginX, e.offsetY)
          } else if (this.rulerhr) {
            this.drawLine(this.x, this.mousedownbeginY, e.offsetX, this.mousedownbeginY)
          } else {
            this.drawLine(this.x, this.y, e.offsetX, e.offsetY)
          }
          this.mouse_x = 0
          this.mouse_y = 0
          this.isDrawing = false
          this.isMouseDown = false
          this.historyPush('Brush Tool')
        } else if (this.actions === 'erase') {
          this.vueCanvas.globalCompositeOperation = 'source-over'
          this.historyPush('Eraser Tool')
        }
      }
      if (this.isMouseDown) {
        this.isMouseDown = false
        this.isDrawing = false
        if (this.actions === 'move') {
          this.drawtemp()
          this.historyPush('Move')
          this.toggle_control_pointer_event(true)
          var bbox = this.getBoundingBox(this.vueCanvas, 0, 0, this.mainCanvas_w, this.mainCanvas_h)
          this.boundingbox_w = bbox.width + 3
          this.boundingbox_h = bbox.height + 3
          this.boundingbox_x = bbox.left - 0.5
          this.boundingbox_y = bbox.top - 0.5
          if (bbox.width > 0 && bbox.height > 0) {
            this.boundingbox_visbile = true
          }
        }
      }
      if (this.scaling) {
        this.scaling = false
      }
      this.bb_scale = false
      if (this.isrotating) {
        if (this.bb_rotate_angle !== 0) {
          this.do_rotate()
        }
      }
      this.isrotating = false
    },
    handleMouseMove (e) {
      this.canvas_x = parseInt(e.offsetX)
      this.canvas_y = parseInt(e.offsetY)
      if (this.actions === 'drawing') {
        this.setcursorpos(e)
        this.draw(e)
      } else if (this.actions === 'erase') {
        this.erase(e)
        this.setcursorpos(e)
      } else if (this.actions === 'move') {
        if (this.bb_scale) {
          this.scaleboundingbox(e)
        } else if (this.isrotating) {
          this.rotate_boundingbox(e)
        } else {
          this.movecanvascontent(e)
        }
      } else if (this.actions === 'shape') {
        // do
        this.drawshape()
      } else if (this.actions === 'select') {
        this.useselect(e)
      }
      if (!this.scaling) {
        if (this.scale_new_x !== this.scale_old_x || this.scale_new_y !== this.scale_old_y || this.scale_new_w !== this.scale_old_w) {
          if (this.scale_new_w !== 0 || this.scale_new_h !== 0) {
            this.scale_it()
          }
        }
      }
      if (this.actions === 'text') {
        if (this.addtext) {
          this.movetexttool(e)
        }
      }
      // this.pixcol(e)
    },
    handleMouseLeave (e) {
      this.isMouseDown = false
      this.isDrawing = false
      this.tempCanvas.clearRect(0, 0, this.mainCanvas_w, this.mainCanvas_h)
    },
    draw (e) {
      if (this.isDrawing) {
        this.vueCanvas.globalCompositeOperation = 'source-over'
        this.vueCanvas.lineWidth = this.brushsize
        // var lasty = this.mousedownbeginX
        if (this.rulervr) {
          this.drawLine(this.mousedownbeginX, this.mouse_y, this.mousedownbeginX, e.offsetY)
        } else if (this.rulerhr) {
          this.drawLine(this.mouse_x, this.mousedownbeginY, e.offsetX, this.mousedownbeginY)
        } else {
          this.drawLine(this.mouse_x, this.mouse_y, e.offsetX, e.offsetY)
        }
        this.mouse_x = e.offsetX
        this.mouse_y = e.offsetY
      }
    },
    erase (e) {
      if (this.isDrawing) {
        this.vueCanvas.globalCompositeOperation = 'destination-out'
        this.vueCanvas.lineWidth = this.erasesize
        this.drawLine(this.mouse_x, this.mouse_y, e.offsetX, e.offsetY)
        this.mouse_x = e.offsetX
        this.mouse_y = e.offsetY
      }
    },
    drawLine (x1, y1, x2, y2) {
      if (this.selecttoolactive) {
        this.vueCanvas.save()
        this.vueCanvas.rect(this.selecttool_x, this.selecttool_y, this.selecttool_w, this.selecttool_h)
        this.vueCanvas.clip()
        this.vueCanvas.beginPath()

        this.vueCanvas.strokeStyle = this.activecolorcode
        this.vueCanvas.lineCap = this.vueCanvas.lineJoin = 'round'
        this.vueCanvas.moveTo(x1, y1)
        this.vueCanvas.lineTo(x2, y2)
        this.vueCanvas.stroke()
        this.vueCanvas.closePath()
        this.vueCanvas.restore()
      } else {
        this.vueCanvas.beginPath()
        this.vueCanvas.strokeStyle = this.activecolorcode
        this.vueCanvas.lineCap = this.vueCanvas.lineJoin = 'round'
        this.vueCanvas.moveTo(x1, y1)
        this.vueCanvas.lineTo(x2, y2)
        this.vueCanvas.stroke()
        this.vueCanvas.closePath()
      }
    },
    setactivelayer (layerID, push = false) {
      if (this.activelayer !== layerID) {
        this.activelayer = layerID
        if (push) {
          this.historyPush('Select Layer')
        }
      }
      this.activelayer = layerID
      // var c = this.$refs.layers[layerID]
      var c = document.getElementById('canvas_' + layerID)
      var ctxa = c.getContext('2d')
      this.vueCanvas = ctxa
      this.boundingbox_visbile = false
    },
    hidelayer (e) {
      if (this.layers[e]['visible'] === true) {
        this.layers[e]['visible'] = false
      } else {
        this.layers[e]['visible'] = true
      }
    },
    addlayer () {
      this.maxlayerid = this.highestLayerID.id + 1
      var layercount = parseInt(this.highestArrayID('normal') + 1)
      var layername = 'Layer ' + layercount
      this.layers.push({
        id: this.maxlayerid,
        visible: true,
        deleted: false,
        typ: 'normal',
        count: layercount,
        name: layername,
      })
      this.historyPush('New Layer')
      this.$nextTick(function () {
        this.setactivelayer(this.layers.length - 1, false)
      })
    },
    deletelayer (e) {
      if (this.layers.length > 1) {
        if (this.activelayer !== 0) {
          if (this.maxlayerid === this.layers[this.activelayer]['id']) {
            this.maxlayerid = this.highestLayerID.id - 1
          }
          this.historyPush('Delete Layer')
          this.$delete(this.layers, this.activelayer)
          // this.layers[this.activelayer]['deleted'] = true
          this.setactivelayer(this.activelayer - 1)
        }
      } else {
        this.$message.error('You cant delete the main layer')
      }
    },
    movelayer (direction) {
      var activelayerID = this.activelayer
      var lowerID = activelayerID - 1
      var upperID = activelayerID + 1
      if (activelayerID > 0) {
        if (direction === 'up') {
          if (upperID < this.layers.length) {
            this.layers.splice(upperID, 0, this.layers.splice(activelayerID, 1)[0])
            this.activelayer = upperID
            this.historyPush('Layer Order')
          }
        } else if (direction === 'down') {
          if (activelayerID > 0) {
            if (lowerID > 0) {
              this.layers.splice(lowerID, 0, this.layers.splice(activelayerID, 1)[0])
              this.activelayer = lowerID
              this.historyPush('Layer Order')
            }
          }
        }
        var layerID = this.activelayer
        // var c = this.$refs.layers[layerID]
        var c = document.getElementById('canvas_' + layerID)
        var ctxa = c.getContext('2d')
        this.vueCanvas = ctxa
      }
      // this.splice(to, 0, this.splice(from, 1)[0])
    },
    duplicatelayer (e) {
      this.maxlayerid = this.highestLayerID.id + 1
      var activelayerID = this.activelayer
      var newname
      var layercount = this.highestArrayID['duplicate']
      var copyname = this.layers[this.activelayer]['name']
      this.duplicateCount = this.duplicateCount + 1
      if (activelayerID === 0) {
        newname = 'Layer'
      } else {
        // var countcopy = parseInt(this.layers[this.activelayer]['copy'])
        newname = copyname
      }
      this.layers.push({
        id: this.maxlayerid,
        visible: true,
        typ: 'duplicate',
        count: layercount,
        name: newname,
      })
      this.historyPush('Duplicate Layer')
      this.$nextTick(function () {
        this.setactivelayer(this.layers.length - 1, false)
        this.vueCanvas.drawImage(this.$refs.layers[activelayerID], 0, 0, this.mainCanvas_w, this.mainCanvas_h)
      })
    },
    movecanvascontent (e) {
      if (this.isMouseDown) {
        this.mouse_x = e.offsetX
        this.mouse_y = e.offsetY
        this.tempCanvas.save()
        this.tempCanvas.clearRect(0, 0, this.mainCanvas_w, this.mainCanvas_h)
        this.tempCanvas.translate(this.mouse_x - this.down_x, this.mouse_y - this.down_y)
        this.tempCanvas.drawImage(document.getElementById('canvas_' + this.activelayer), 0, 0, this.mainCanvas_w, this.mainCanvas_h)
        this.tempCanvas.restore()
      } else {
        this.down_y = 0
        this.down_x = 0
      }
    },
    movecanvascontentbykey (direction) {
      var left = 0
      var top = 0
      if (direction === 'right') {
        left = 10
      }
      this.tempCanvas.save()
      this.tempCanvas.clearRect(0, 0, this.mainCanvas_w, this.mainCanvas_h)
      this.tempCanvas.drawImage(this.$refs.layers[this.activelayer], left, top, this.mainCanvas_w, this.mainCanvas_h)
      this.tempCanvas.restore()
      this.drawtemp()
    },
    drawtemp () {
      // var bbox = this.getBoundingBox(document.getElementById('dc-temp-canvas'), 0, 0, this.mainCanvas_w, this.mainCanvas_h)
      if (!this.isCanvasEmpty(document.getElementById('dc-temp-canvas'))) {
        this.vueCanvas.globalCompositeOperation = 'source-over'
        this.vueCanvas.clearRect(0, 0, this.mainCanvas_w, this.mainCanvas_h)
        this.vueCanvas.drawImage(document.getElementById('dc-temp-canvas'), 0, 0, this.mainCanvas_w, this.mainCanvas_h)
        this.tempCanvas.clearRect(0, 0, this.mainCanvas_w, this.mainCanvas_h)
      }
    },
    drawcanvasmask (e) {
      var canvasmask = document.getElementById('canvasmask')
      this.maskCanvas = canvasmask.getContext('2d')
      this.maskCanvas.globalCompositeOperation = 'source-over'
      this.maskCanvas.beginPath()
      this.maskCanvas.fillStyle = '#eee'
      this.maskCanvas.rect(0, 0, this.mainCanvas_w, this.mainCanvas_h)
      this.maskCanvas.fill()
      this.maskCanvas.closePath()

      this.maskCanvas.beginPath()

      var maskCanvasPaddingX = (this.mainCanvas_w - this.frameCanvas_w) / 2
      var maskCanvasPaddingY = (this.mainCanvas_h - this.frameCanvas_h) / 2

      this.maskCanvas.globalCompositeOperation = 'destination-out'
      this.maskCanvas.rect(maskCanvasPaddingX, maskCanvasPaddingY, this.frameCanvas_w, this.frameCanvas_h)
      this.maskCanvas.fill()
    },
    getBoundingBox (ctx, left, top, width, height) {
      var ret = {}

      var data = ctx.getImageData(left, top, width, height).data
      var first = false
      var last = false
      var right = false
      left = false
      var r = height
      var c = 0

      // 1. get bottom
      while (!last && r) {
        r--
        for (c = 0; c < width; c++) {
          if (data[r * width * 4 + c * 4 + 3]) {
            last = r + 1
            ret.bottom = r + 1
            break
          }
        }
      }

      // 2. get top
      r = 0
      while (!first && r < last) {
        for (c = 0; c < width; c++) {
          if (data[r * width * 4 + c * 4 + 3]) {
            first = r - 1
            ret.top = r - 1
            ret.height = last - first - 1
            break
          }
        }
        r++
      }

      // 3. get right
      c = width
      while (!right && c) {
        c--
        for (r = 0; r < height; r++) {
          if (data[r * width * 4 + c * 4 + 3]) {
            right = c + 1
            ret.right = c + 1
            break
          }
        }
      }

      // 4. get left
      c = 0
      while (!left && c < right) {
        for (r = 0; r < height; r++) {
          if (data[r * width * 4 + c * 4 + 3]) {
            left = c
            ret.left = c
            ret.width = right - left - 1
            break
          }
        }
        c++

        if (left) {
          return ret
        }
      }
      return false
    },
    setboundingbox () {
      var bbox = this.getBoundingBox(this.vueCanvas, 0, 0, this.mainCanvas_w, this.mainCanvas_h)
      this.boundingbox_w = bbox.width + 3
      this.boundingbox_h = bbox.height + 3
      this.boundingbox_x = bbox.left - 0.5
      this.boundingbox_y = bbox.top - 0.5
    },
    scaleboundingbox () {
      this.tempCanvas.save()
      this.tempCanvas.clearRect(0, 0, this.mainCanvas_w, this.mainCanvas_h)

      var scalefactor = 1
      var scaleRatio = 1
      var scaleRatioX = 1
      var scaleRatioY = 1
      var widthDifference = this.boundingbox_w - this.scale_old_w
      var heightDifference = this.boundingbox_h - this.scale_old_h
      var newTranslateX = 0
      var newTranslateY = 0

      var PxToPrzX = (100 / this.scale_old_w) // Breite : 1px = X %
      // var PxToPrzY = (100 / this.scale_old_y)
      // var PrzToPxX = (this.scale_old_x / 100)
      var PrzToPxY = (this.scale_old_h / 100) // Höhe : 1 % = X px

      switch (this.scale_direction) {
        case 'se':
          scalefactor = this.canvas_x - (this.boundingbox_x + this.boundingbox_w)

          this.scale_new_w = this.boundingbox_w
          this.scale_new_h = this.boundingbox_h

          var newWidthinPx = PxToPrzX * widthDifference // (1px in %) x neueBreite = x %
          var prozentY = PrzToPxY * newWidthinPx // 12 * 12 %

          this.boundingbox_w = this.boundingbox_w + scalefactor
          this.boundingbox_h = this.scale_old_h + prozentY

          widthDifference = this.boundingbox_w - this.scale_old_w
          scaleRatio = (widthDifference / this.scale_old_w) + 1

          scaleRatioX = scaleRatio
          scaleRatioY = scaleRatio
          newTranslateX = (-this.boundingbox_x * (scaleRatio - 1))
          newTranslateY = (-this.boundingbox_y * (scaleRatio - 1))
          break

        case 'ne':
          scalefactor = this.canvas_x - (this.boundingbox_x + this.boundingbox_w)
          this.scale_new_w = this.boundingbox_w
          this.scale_new_h = this.boundingbox_h

          newWidthinPx = PxToPrzX * widthDifference
          prozentY = PrzToPxY * newWidthinPx

          this.boundingbox_y = (this.scale_old_h + this.scale_old_y) - (this.scale_old_h) - prozentY
          this.boundingbox_w = this.boundingbox_w + scalefactor
          this.boundingbox_h = this.scale_old_h + prozentY

          widthDifference = this.boundingbox_w - this.scale_old_w
          scaleRatio = (widthDifference / this.scale_old_w) + 1

          scaleRatioX = scaleRatio
          scaleRatioY = scaleRatio
          newTranslateX = (-this.boundingbox_x * (scaleRatio - 1))
          newTranslateY = (-(this.boundingbox_y + this.boundingbox_h) * (scaleRatio - 1))

          break

        case 'sw':
          this.scale_new_w = this.boundingbox_w
          this.scale_new_h = this.boundingbox_h

          var bbNewWidth = this.boundingbox_w + (this.boundingbox_x - this.canvas_x)

          newWidthinPx = PxToPrzX * widthDifference
          prozentY = PrzToPxY * newWidthinPx

          // this.boundingbox_y = this.boundingbox_y
          this.boundingbox_w = bbNewWidth
          this.boundingbox_x = this.canvas_x
          this.boundingbox_h = this.scale_old_h + prozentY

          scaleRatio = (widthDifference / this.scale_old_w) + 1
          scaleRatioX = scaleRatio
          scaleRatioY = scaleRatio
          newTranslateX = -((this.boundingbox_x + this.boundingbox_w) * (scaleRatio - 1))
          newTranslateY = (-(this.boundingbox_y) * (scaleRatio - 1))

          break

        case 'nw':
          this.scale_new_w = this.boundingbox_w
          this.scale_new_h = this.boundingbox_h

          newWidthinPx = PxToPrzX * (this.scale_old_x - this.canvas_x)
          prozentY = PrzToPxY * newWidthinPx

          this.boundingbox_y = this.scale_old_y - prozentY
          this.boundingbox_w = this.scale_old_w + (this.scale_old_x - this.canvas_x)
          this.boundingbox_x = this.canvas_x
          this.boundingbox_h = this.scale_old_h + prozentY

          widthDifference = this.boundingbox_w - this.scale_old_w
          scaleRatio = (widthDifference / this.scale_old_w) + 1
          scaleRatioX = scaleRatio
          scaleRatioY = scaleRatio
          newTranslateX = -((this.boundingbox_x + this.boundingbox_w) * (scaleRatio - 1))
          newTranslateY = (-(this.boundingbox_y + this.boundingbox_h) * (scaleRatio - 1))

          break

        case 'east':
          this.scale_new_w = this.boundingbox_w
          this.scale_new_h = this.boundingbox_h
          var newidth = this.canvas_x - (this.scale_old_w + this.scale_old_x)

          scaleRatioX = (widthDifference / this.scale_old_w) + 1
          newTranslateX = -this.scale_old_x * (scaleRatioX - 1)

          this.boundingbox_y = this.scale_old_y
          this.boundingbox_w = this.scale_old_w + newidth
          this.boundingbox_x = this.scale_old_x
          this.boundingbox_h = this.scale_old_h

          break

        case 'west':
          this.scale_new_w = this.boundingbox_w
          this.scale_new_h = this.boundingbox_h

          newidth = this.scale_old_x - this.canvas_x

          scaleRatioX = (widthDifference / this.scale_old_w) + 1
          newTranslateX = -(this.scale_old_x + this.scale_old_w) * (scaleRatioX - 1)

          this.boundingbox_y = this.scale_old_y
          this.boundingbox_w = this.scale_old_w + newidth
          this.boundingbox_x = this.canvas_x
          this.boundingbox_h = this.scale_old_h

          break

        case 'south':
          this.scale_new_w = this.boundingbox_w
          this.scale_new_h = this.boundingbox_h

          var newheight = this.canvas_y - (this.scale_old_h + this.scale_old_y)
          scaleRatioY = (heightDifference / this.scale_old_h) + 1
          newTranslateY = -this.scale_old_y * (scaleRatioY - 1)

          this.boundingbox_y = this.scale_old_y
          this.boundingbox_w = this.scale_old_w
          this.boundingbox_x = this.scale_old_x
          this.boundingbox_h = this.scale_old_h + newheight
          break

        case 'north':
          this.scale_new_w = this.boundingbox_w
          this.scale_new_h = this.boundingbox_h

          var newY = this.scale_old_y - this.canvas_y

          scaleRatioY = (heightDifference / this.scale_old_h) + 1
          newTranslateY = -(this.scale_old_h + this.scale_old_y) * (scaleRatioY - 1)

          this.boundingbox_y = this.canvas_y
          this.boundingbox_w = this.scale_old_w
          this.boundingbox_x = this.scale_old_x
          this.boundingbox_h = this.scale_old_h + newY
          break
      }

      this.tempCanvas.translate(newTranslateX, newTranslateY)
      this.tempCanvas.scale(scaleRatioX, scaleRatioY)
      var c = document.getElementById('canvas_' + this.activelayer)
      this.tempCanvas.drawImage(c, 0, 0, this.mainCanvas_w, this.mainCanvas_h)
      this.tempCanvas.restore()
    },
    start_scaleboundingbox (direction) {
      this.bb_scale = true
      this.scaling = true
      this.scale_direction = direction

      this.scale_old_x = this.boundingbox_x
      this.scale_old_y = this.boundingbox_y
      this.scale_old_w = this.boundingbox_w
      this.scale_old_h = this.boundingbox_h

      this.toggle_control_pointer_event(false)
    },
    scale_it () {
      this.drawtemp()
      this.historyPush('Transform Scale')
      this.setboundingbox()
      this.toggle_control_pointer_event(true)
      this.scale_new_x = 0
      this.scale_new_y = 0
      this.scale_new_h = 0
      this.scale_new_w = 0
    },
    start_rotateboundingbox () {
      this.isrotating = true
      this.toggle_control_pointer_event(false)
    },
    rotate_boundingbox (e) {
      this.tempCanvas.clearRect(0, 0, this.mainCanvas_w, this.mainCanvas_h)
      this.tempCanvas.save()

      var x = (this.boundingbox_w + (this.boundingbox_x * 2)) / 2
      var y = (this.boundingbox_h + (this.boundingbox_y * 2)) / 2

      var cx = this.mainCanvas_w / 2
      var cy = this.mainCanvas_h / 2

      var mx = this.canvas_x
      var my = this.canvas_y

      var angle = Math.atan2(my - cy, mx - cx) * 180 / Math.PI
      angle += 90
      if (angle < 0) { angle = 360 + angle }

      var rotation = angle * (Math.PI / 180)

      this.boundingbox_rotate = angle
      this.tempCanvas.translate(x, y)
      this.tempCanvas.rotate(rotation)
      this.tempCanvas.drawImage(this.$refs.layers[this.activelayer], -x, -y, this.mainCanvas_w, this.mainCanvas_h)
      this.tempCanvas.restore()

      this.bb_rotate_angle = angle
      angle = 0
    },
    do_rotate () {
      this.bb_rotate_angle = 0
      this.boundingbox_rotate = 0
      this.drawtemp()
      this.historyPush('Transform Rotation')
      this.setboundingbox()
      this.toggle_control_pointer_event(true)
    },
    rotateimage (ratio) {
      if (this.actions === 'text') {
        this.TextToolAction('cancel')
      }
      if (this.isCanvasEmpty(this.$refs.layers[this.activelayer])) {
        this.$message.error('You cant rotate an empty layer!')
      } else {
        var bbox = this.getBoundingBox(this.vueCanvas, 0, 0, this.mainCanvas_w, this.mainCanvas_h)
        this.boundingbox_w = bbox.width + 3
        this.boundingbox_h = bbox.height + 3
        this.boundingbox_x = bbox.left - 0.5
        this.boundingbox_y = bbox.top - 0.5

        var rotation = ratio * Math.PI / 180
        var x = 0
        var y = 0

        x = (this.boundingbox_w + (this.boundingbox_x * 2)) / 2
        y = (this.boundingbox_h + (this.boundingbox_y * 2)) / 2

        this.tempCanvas.save()
        this.tempCanvas.translate(x, y)
        this.tempCanvas.rotate(rotation)
        this.tempCanvas.drawImage(this.$refs.layers[this.activelayer], -x, -y, this.mainCanvas_w, this.mainCanvas_h)
        this.tempCanvas.restore()
        this.drawtemp()
        this.setboundingbox()
        this.historyPush('Rotate')
      }
    },
    flipimage (direction) {
      if (this.actions === 'text') {
        this.TextToolAction('cancel')
      }
      if (this.isCanvasEmpty(this.$refs.layers[this.activelayer])) {
        this.$message.error('You cant flip an empty layer!')
      } else {
        this.vueCanvas.globalCompositeOperation = 'source-over'
        this.tempCanvas.save()
        var scaleX = 1
        var scaleY = 1

        var translateX = 0
        var translateY = 0

        if (direction === 'horizontal') {
          translateX = this.mainCanvas_w
          this.tempCanvas.translate(translateX, translateY)
          this.tempCanvas.scale(-1, scaleY)
        } else {
          translateY = this.mainCanvas_h
          this.tempCanvas.translate(translateX, translateY)
          this.tempCanvas.scale(scaleX, -1)
        }
        this.tempCanvas.drawImage(this.$refs.layers[this.activelayer], 0, 0, this.mainCanvas_w, this.mainCanvas_h)
        this.tempCanvas.restore()

        this.vueCanvas.clearRect(0, 0, this.mainCanvas_w, this.mainCanvas_h)
        this.vueCanvas.drawImage(document.getElementById('dc-temp-canvas'), 0, 0, this.mainCanvas_w, this.mainCanvas_h)
        this.tempCanvas.clearRect(0, 0, this.mainCanvas_w, this.mainCanvas_h)
        this.setboundingbox()
        if (direction === 'horizontal') {
          this.historyPush('Flip Horizontally')
        } else {
          this.historyPush('Flip Vertically')
        }
      }
    },
    isCanvasEmpty (cnv) {
      const blank = document.createElement('canvas')
      blank.width = cnv.width
      blank.height = cnv.height
      return cnv.toDataURL() === blank.toDataURL()
    },
    toggle_control_pointer_event (on) {
      if (on) {
        document.getElementById('br-control').style.pointerEvents = 'auto'
        document.getElementById('bl-control').style.pointerEvents = 'auto'
        document.getElementById('tr-control').style.pointerEvents = 'auto'
        document.getElementById('tl-control').style.pointerEvents = 'auto'
        document.getElementById('rotate-control').style.pointerEvents = 'auto'
        document.getElementById('west-control').style.pointerEvents = 'auto'
        document.getElementById('east-control').style.pointerEvents = 'auto'
        document.getElementById('south-control').style.pointerEvents = 'auto'
        document.getElementById('north-control').style.pointerEvents = 'auto'
      } else {
        document.getElementById('br-control').style.pointerEvents = 'none'
        document.getElementById('bl-control').style.pointerEvents = 'none'
        document.getElementById('tr-control').style.pointerEvents = 'none'
        document.getElementById('tl-control').style.pointerEvents = 'none'
        document.getElementById('rotate-control').style.pointerEvents = 'none'
        document.getElementById('west-control').style.pointerEvents = 'none'
        document.getElementById('east-control').style.pointerEvents = 'none'
        document.getElementById('south-control').style.pointerEvents = 'none'
        document.getElementById('north-control').style.pointerEvents = 'none'
      }
    },
    historyUndo () {
      if (this.historyStep > 0) {
        this.historyStep--
        this.historySelect(this.historyStep)
      }
    },
    historyRedo () {
      if (this.historyStep < this.historyArray.length - 1) {
        this.historyStep++
        this.historySelect(this.historyStep)
      }
    },
    historyPush (typ) {
      this.historyStep++ // Neuer Step
      if (this.historyStep < this.historyArray.length) {
        this.historyArray.length = this.historyStep
      }
      if (this.historyArray.length > this.historyLenght) {
        this.historyArray.splice(0, 1)
      }
      var layerArray = []
      layerArray.splice(0)
      var count = 0
      for (let i = 0; i < this.layers.length; i++) { // aktuelle Layer im Array speichern
        layerArray[i] = []
        layerArray[i]['id'] = this.layers[i]['id']
        layerArray[i]['visible'] = this.layers[i]['visible']
        layerArray[i]['deleted'] = this.layers[i]['deleted']
        count++
      }
      this.$nextTick(function () {
        var testarray = this.layers.slice()
        if (layerArray.length === count) {
          if (typ !== 'Open') {
            this.isEditing = true
          } else {
            this.isEditing = false
          }

          switch (typ) {
            case 'Brush Tool':
              this.historyArray.push({
                layerid: this.activelayer,
                url: this.$refs.layers[this.activelayer].toDataURL(),
                typ: typ,
                newid: 0,
                layers: testarray,
                showinhistory: true,
                frame_w: this.frameCanvas_w,
                frame_h: this.frameCanvas_h,
              })
              testarray = []
              break
            case 'New Layer':
              this.historyArray.push({
                layerid: this.activelayer,
                url: '',
                typ: typ,
                newid: this.activelayer + 1,
                layers: testarray,
                showinhistory: true,
                frame_w: this.frameCanvas_w,
                frame_h: this.frameCanvas_h,
              })
              testarray = []
              // layerArray.splice(0)
              break
            case 'Select Layer':
              // oo
              this.historyArray.push({
                layerid: this.activelayer,
                url: this.$refs.layers[this.activelayer].toDataURL(),
                typ: typ,
                newid: 0,
                layers: testarray,
                showinhistory: false,
                frame_w: this.frameCanvas_w,
                frame_h: this.frameCanvas_h,
              })
              break
            case 'Image import':
              this.historyArray.push({
                layerid: this.activelayer,
                url: this.$refs.layers[this.activelayer].toDataURL(),
                typ: typ,
                newid: this.activelayer + 1,
                layers: testarray,
                showinhistory: true,
                frame_w: this.frameCanvas_w,
                frame_h: this.frameCanvas_h,
              })
              break
            case 'Canvas Size':
              this.historyArray.push({
                layerid: this.activelayer,
                url: this.$refs.layers[this.activelayer].toDataURL(),
                typ: typ,
                newid: this.activelayer + 1,
                layers: testarray,
                showinhistory: true,
                frame_w: this.frameCanvas_w,
                frame_h: this.frameCanvas_h,
              })
              break
            default:
              this.historyArray.push({
                layerid: this.activelayer,
                url: this.$refs.layers[this.activelayer].toDataURL(),
                typ: typ,
                newid: 0,
                layers: testarray,
                showinhistory: true,
                frame_w: this.frameCanvas_w,
                frame_h: this.frameCanvas_h,
              })
              testarray = []
              //  layerArray.splice(0)
              break
          }
          testarray = []
        }
        this.$nextTick(function () { // Wenn History geladen
          var objDiv = document.getElementById('history') // Div auswählen
          objDiv.scrollTop = objDiv.scrollHeight - objDiv.clientHeight // runtersrcollen
        })
      })
    },
    historySelect (step) {
      this.historyStep = step
      var typ = this.historyArray[this.historyStep]['typ']
      if (step === 0 && typ === 'Open Project') {
        var projectlayer = this.projectArray[step]['layer'].slice()
        var framew = this.projectArray[step]['frame_w']
        var frameh = this.projectArray[step]['frame_h']
        this.layers = null
        this.layers = this.projectArray[step]['layer'].slice()
        this.$nextTick(function () {
          for (let i = 0; i < projectlayer.length; i++) {
            var imgurl = projectlayer[i].imgdata
            var layer = document.getElementById('canvas_' + i)
            this.drawfunc(imgurl, layer, framew, frameh, false)
          }
          this.frameCanvas_w = parseInt(framew)
          this.frameCanvas_h = parseInt(frameh)
          this.drawcanvasmask()
        })
      } else {
        this.addtext = false
        this.layers = this.historyArray[this.historyStep]['layers'].slice()
        this.$nextTick(function () {
          var img = new Image()
          var layerID = this.historyArray[this.historyStep]['layerid']
          var imgurl = this.historyArray[this.historyStep]['url']
          this.frameCanvas_w = this.historyArray[this.historyStep]['frame_w']
          this.frameCanvas_h = this.historyArray[this.historyStep]['frame_h']
          var canvaswidth = this.mainCanvas_w
          var canvasheight = this.mainCanvas_h
          var PaddingX = 0
          var PaddingY = 0

          img.src = imgurl

          var canvas = this.$refs.layers[layerID]
          var canvasctx = canvas.getContext('2d')
          this.drawcanvasmask()

          switch (typ) {
            case 'New Layer':
              var NewlayerCanvasID = this.historyArray[this.historyStep]['newid']
              var NewlayerCanvas = this.$refs.layers[NewlayerCanvasID]
              var NewlayerCanvasCtx = NewlayerCanvas.getContext('2d')
              NewlayerCanvasCtx.clearRect(0, 0, this.mainCanvas_w, this.mainCanvas_h)
              this.setactivelayer(NewlayerCanvasID)
              break
            default:
              img.onload = function () {
                canvasctx.clearRect(0, 0, canvaswidth, canvasheight)
                canvasctx.drawImage(img, PaddingX, PaddingY, canvaswidth, canvasheight)
              }
              this.setactivelayer(layerID)
              break
          }
        })
      }
    },
    async domultiselect (steps) {
      for (var i = 0; i <= steps; i++) {
        await this.historySelect(i)
      }
    },
    toggleShapeColorOptions () {
      if (this.showshapefillcolor) {
        this.showshapefillcolor = false
      } else {
        this.showshapefillcolor = true
      }
    },
    scrolltoMid () {
      var CanvasWidth = this.mainCanvas_w / 100 * this.zoompercent
      var CanvasHeight = this.mainCanvas_h / 100 * this.zoompercent
      var x = 0
      var y = 0
      if (this.mainCanvas_w > CanvasWidth) {
        x = (this.mainCanvas_w - this.canvashelper_w) / 2
        y = (this.mainCanvas_h - this.canvashelper_h) / 2
      } else {
        x = (CanvasWidth - this.canvashelper_w) / 2
        y = (CanvasHeight - this.canvashelper_h) / 2
      }
      this.$refs.canvashelper.scrollTo(x, y)
    },
    ruler (direction) {
      if (direction === 'hr') {
        this.rulervr = false
        if (this.rulerhr) {
          this.rulerhr = false
        } else {
          this.rulerhr = true
        }
      }
      if (direction === 'vr') {
        this.rulerhr = false
        if (this.rulervr) {
          this.rulervr = false
        } else {
          this.rulervr = true
        }
      }
    },
    updateDrawColor (color) {
      this.activecolorcode = color.hex8
    },
    updateFontColor (color) {
      this.texttoolColor = color.hex8
    },
    selectshape (id) {
      this.activeshape = id
    },
    drawshape (e) {
      if (this.isMouseDown) {
        this.tempCanvas.clearRect(0, 0, this.mainCanvas_w, this.mainCanvas_h) // Temp Canvas leeren
        this.tempCanvas.lineWidth = this.shapeStrokeSize

        var newX = this.canvas_x - this.mousedownbeginX
        var newY = this.canvas_y - this.mousedownbeginY

        if (this.shapes[this.activeshape]['name'] === 'rect') {
          this.tempCanvas.fillStyle = this.shapeFill
          this.tempCanvas.strokeStyle = this.shapeStroke
          this.tempCanvas.beginPath()
          this.tempCanvas.rect(this.mousedownbeginX, this.mousedownbeginY, newX, newY)
          if (this.shapeStroke !== '') {
            this.tempCanvas.stroke()
          }
          if (this.shapeFill !== '') {
            this.tempCanvas.fill()
          }
          this.tempCanvas.closePath()
        } else if (this.shapes[this.activeshape]['name'] === 'circle') {
          this.drawOval(this.mousedownbeginX, this.mousedownbeginY, this.canvas_x, this.canvas_y)
        } else {
          this.tempCanvas.save()
          var pathstring = this.shapes[this.activeshape]['path']

          var path = new Path2D(pathstring)
          var width = this.shapes[this.activeshape]['width']
          var height = this.shapes[this.activeshape]['height']

          var scaleX = newX / width
          var scaleY = newY / height

          this.tempCanvas.fillStyle = this.shapeFill
          this.tempCanvas.strokeStyle = this.shapeStroke

          var m1 = new DOMMatrix()
          m1 = m1.translate(this.mousedownbeginX, this.mousedownbeginY)
          m1 = m1.scaleSelf(scaleX, scaleY)

          if (this.shapeStroke !== '') {
            this.tempCanvas.stroke(this.transformPath2D(path, m1))
          }
          if (this.shapeFill !== '') {
            this.tempCanvas.fill(this.transformPath2D(path, m1))
          }
          this.tempCanvas.setTransform(1, 0, 0, 1, 0, 0)
        }
        this.addshape = true
      } else if (this.addshape) {
        this.addshape = false
        this.shapeCount = this.highestArrayID('shape') + 1
        this.maxlayerid = this.highestLayerID.id + 1
        this.layers.push({
          id: this.maxlayerid,
          visible: true,
          deleted: false,
          typ: 'shape',
          count: this.shapeCount,
          name: 'Shape ' + this.shapeCount,
          x: 0,
          y: 0,
          w: 0,
          h: 0,
        })
        this.$nextTick(function () {
          this.setactivelayer(this.layers.length - 1, false)
          this.drawtemp()
          this.tempCanvas.clearRect(0, 0, this.mainCanvas_w, this.mainCanvas_h)
          this.historyPush('Custom Shape')
        })
      }
    },
    drawOval (startX, startY, x, y) {
      this.tempCanvas.beginPath()
      this.tempCanvas.fillStyle = this.shapeFill
      this.tempCanvas.strokeStyle = this.shapeStroke
      this.tempCanvas.moveTo(startX, startY + (y - startY) / 2)
      this.tempCanvas.bezierCurveTo(startX, startY, x, startY, x, startY + (y - startY) / 2)
      this.tempCanvas.bezierCurveTo(x, y, startX, y, startX, startY + (y - startY) / 2)
      this.tempCanvas.closePath()
      if (this.shapeFill !== '') {
        this.tempCanvas.fill()
      }
      if (this.shapeStroke !== '') {
        this.tempCanvas.stroke()
      }
    },
    transformPath2D (path, matrix) {
      const p = new Path2D()
      p.addPath(path, matrix)
      return p
    },
    ImportImage (e) {
      if (e.target.files.length) {
        this.imageimportfile = true
      } else {
        this.imageimportfile = false
      }
      var reader = e.target.files
      var files = e.target.files
      reader = new FileReader()
      reader.onload = (e) => {
        this.importfile = e.target.result
      }
      reader.readAsDataURL(files[0])
      // this.$refs.ImageImport.value = null
    },
    ImportImageMedia (e) {
      if (this.importImageFile.id !== '') {
        this.imageimportfile = true
        var FileName = this.importImageFile.name
        var FileExtension = FileName.split('.').pop()
        if (FileExtension === 'jpg' || FileExtension === 'jpeg' || FileExtension === 'png') {
          Api.files().getFile(this.importImageFile.id).then(Response => {
            Response.blob().then(blob => {
              this.importfile = blob
              var reader = blob
              reader = new FileReader()
              reader.onload = (e) => {
                this.importfile = e.target.result
              }
              reader.readAsDataURL(blob)
            })
          })
        } else {
          this.imageimportfile = false
        }
      } else {
        console.log('after ' + this.importImageFile.id)
        this.importfile = null
        this.imageimportfile = false
      }
    },
    doImportImage (upload) {
      var img = new Image()
      img.src = this.importfile
      this.maxlayerid = this.highestLayerID.id + 1
      var imagecount = this.highestArrayID('image') + 1
      this.layers.push({
        id: this.maxlayerid,
        visible: true,
        deleted: false,
        typ: 'image',
        name: 'Image ' + imagecount,
        count: imagecount,
        x: 0,
        y: 0,
        w: 0,
        h: 0,
      })
      this.$nextTick(function () {
        this.setactivelayer(this.layers.length - 1, false)
        var canvas = this.$refs.layers[this.activelayer]
        var canvasctx = canvas.getContext('2d')
        var scaledwidth = 0
        var scaledheight = 0
        var scaleddiff = 0
        if (img.width > img.height) {
          scaleddiff = this.frameCanvas_w / img.width
          scaledwidth = this.frameCanvas_w
          scaledheight = img.height * scaleddiff
        } else {
          scaleddiff = this.frameCanvas_h / img.height
          scaledwidth = img.width * scaleddiff
          scaledheight = this.frameCanvas_h
        }
        if (this.scaleimport) {
          canvasctx.drawImage(img, this.mainCanvas_w / 2 - scaledwidth / 2, this.mainCanvas_h / 2 - scaledheight / 2, scaledwidth, scaledheight)
        } else {
          canvasctx.drawImage(img, this.mainCanvas_w / 2 - img.width / 2, this.mainCanvas_h / 2 - img.height / 2)
        }
        this.actions = 'move'
        this.boundingbox_visbile = true
        this.setboundingbox()
        this.historyPush('Image import')
        this.$refs.RefImageImport.value = null
        this.modalimageimport = false
        this.imageimportfile = false
      })
    },
    resetZoom () {
      var zoom = 100

      var widthforzoom = parseInt(this.frameCanvas_w) + 150
      var heightforzoom = parseInt(this.frameCanvas_h) + 150
      if (this.frameCanvas_w > (this.canvashelper_w - 10) || this.frameCanvas_h > (this.canvashelper_h - 10)) {
        if (this.frameCanvas_w > this.frameCanvas_h) {
          zoom = (100 / widthforzoom) * this.canvashelper_w
          if (this.frameCanvas_w > this.canvashelper_w) {
            zoom = (100 / widthforzoom) * this.canvashelper_w
          }
          if (this.frameCanvas_h >= this.canvashelper_h) {
            zoom = (100 / heightforzoom) * this.canvashelper_h
          }
        } else {
          zoom = (100 / heightforzoom) * this.canvashelper_h
        }
      }
      this.zoompercent = zoom
    },
    createnewproject () {
      this.frameCanvas_w = parseInt(this.projectwidth)
      this.frameCanvas_h = parseInt(this.projectheight)
      this.newframe_w = parseInt(this.projectwidth)
      this.newframe_h = parseInt(this.projectheight)
      this.resetZoom()
      this.layers = [{
        id: 0,
        visible: true,
        deleted: false,
        typ: 'normal',
      }]
      this.activelayer = 0
      var c = this.$refs.layers[this.activelayer]
      var ctx = c.getContext('2d')
      this.vueCanvas = ctx
      this.vueCanvas.clearRect(0, 0, this.mainCanvas_w, this.mainCanvas_h)
      this.historyArray.length = 0
      this.historyStep = -1
      this.historyPush('Open')
      this.drawcanvasmask()

      this.modalnewproject = false
      this.showstartscreen = false
    },
    resizeFrameCanvas () {
      this.frameCanvas_w = parseInt(this.newframe_w)
      this.frameCanvas_h = parseInt(this.newframe_h)
      this.modalcanvassize = false
      this.drawcanvasmask()
      this.resetZoom()
      this.historyPush('Canvas Size')
    },
    openimagesavemodal () {
      this.modalsaveimage = true
      var widthcalc
      this.$nextTick(function () {
        this.drawresultforexport(this.exportfileformat)
        if (this.frameCanvas_w < 500) {
          widthcalc = (360 + this.frameCanvas_w)
        } else {
          widthcalc = 800
        }

        this.modalsavewidth = widthcalc + 'px'
      })
    },
    drawresultforexport (file) {
      var resultc = document.getElementById('result-canvas')
      var resultctx = resultc.getContext('2d')
      // var canvaswidth = this.mainCanvas_w
      // var canvasheight = this.mainCanvas_h
      var resultimage = document.getElementById('result-imageY')

      var sourceX = (this.mainCanvas_w - this.frameCanvas_w) / 2
      var sourceY = (this.mainCanvas_h - this.frameCanvas_h) / 2

      var sourceWidth = this.frameCanvas_w
      var sourceHeight = this.frameCanvas_h

      var destX = 0
      var destY = 0

      var destWidth = this.frameCanvas_w
      var destHeight = this.frameCanvas_h
      resultctx.clearRect(0, 0, this.frameCanvas_w, this.frameCanvas_h)
      if (file === 'jpg') {
        resultctx.fillStyle = this.exportimagebackground
        resultctx.fillRect(0, 0, this.frameCanvas_w, this.frameCanvas_h)
      }
      for (let i = 0; i < this.layers.length; i++) {
        if (this.layers[i]['visible']) {
          // var layerID = this.layers[i]['id']
          // resultctx.drawImage(this.$refs.layers[i], 0, 0, canvaswidth, canvasheight)
          var canvas = document.getElementById('canvas_' + i)
          resultctx.drawImage(canvas, sourceX, sourceY, sourceWidth, sourceHeight, destX, destY, destWidth, destHeight)
        }
      }
      if (!this.isCanvasEmpty(resultc)) { this.enableexport = true } else { this.enableexport = false }
      resultimage.src = resultc.toDataURL('image/png')
    },
    changeExportColor (color) {
      this.exportimagebackground = color.hex
    },
    downloadimage () {
      var canvas = document.getElementById('result-canvas')
      var img
      var filename = ''
      if (this.exportfileformat === 'png') {
        img = canvas.toDataURL('image/png')
        filename = this.filename + '.png'
      } else {
        img = canvas.toDataURL('image/jpeg', 1)
        filename = this.filename + '.jpg'
      }
      var link = document.createElement('a')
      link.download = filename
      link.href = img
      link.click()
      this.modalsaveimage = false
      // Api.files().uploadFile({ file: this.dataURItoBlob(img), module: 'files', name: filename })
    },
    uploadimage () {
      var canvas = document.getElementById('result-canvas')
      var img
      var filename = ''
      if (this.exportfileformat === 'png') {
        img = canvas.toDataURL('image/png')
        filename = this.filename + '.png'
      } else {
        img = canvas.toDataURL('image/jpeg', 1)
        filename = this.filename + '.jpg'
      }
      var upload = Api.files().uploadFile({ file: this.dataURItoBlob(img), module: 'files', name: filename })
      if (upload) {
        this.$message.success('.bsd File successfully uploaded to system')
        this.modalsaveimage = false
      } else {
        this.$message.error('Something went wrong')
      }
    },
    dataURItoBlob (dataURI) {
      var byteString
      if (dataURI.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataURI.split(',')[1])
      } else {
        byteString = unescape(dataURI.split(',')[1])
      }
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

      var ia = new Uint8Array(byteString.length)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ia], { type: mimeString })
    },
    UploadtoBrez (file, filename) {
      if (!filename) filename = 'Unbenannt'
      var upload = Api.files().uploadFile({ file: file, module: 'files', name: filename })
      if (upload) {
        this.$message.success('.bsd File successfully uploaded to system')
      } else {
        this.$message.error('Something went wrong')
      }
    },
    highestArrayID (typ) {
      var max = 0
      var arr = this.layers.slice()
      arr.forEach(layer => {
        if (layer.count > max && layer.typ === typ) {
          max = layer.count
        }
      })
      return max
    },
    createTextField () {
      this.isDragging = false
      this.texttool_start_x = this.texttool_x
      this.texttool_start_y = this.texttool_y
      if (this.addtext === false) {
        var x = this.canvas_x
        var y = this.canvas_y
        var textarea = this.$refs.texttoolref
        this.addtext = true
        textarea.innerText = ''
        this.texttool_x = x
        this.texttool_y = y
        this.texttool_start_x = x
        this.texttool_start_y = y
        this.$nextTick(function () {
          textarea.focus()
          // textarea.style.lineHeight = this.texttoolSize + 'px'
        })
      } else {
        this.isDragging = true
      }
    },
    TextToolAction (action) {
      var textarea = this.$refs.texttoolref
      if (action === 'draw') {
        this.DrawTexttoCanvas()
        this.texttoolcopy = ''
      } else if (action === 'cancel') {
        textarea.innerText = ''
        this.texttoolcopy = ''
        this.addtext = false
      }
    },
    texttoolchange () {
      var text = this.$refs.texttoolref.innerText
      if (text !== '') {
        this.texttoolcopy = this.$refs.texttoolref.innerHTML
      }
    },
    DrawTexttoCanvas () {
      var textarea = this.$refs.texttoolref
      var textareatext = textarea.innerText
      var x = parseInt(this.texttool_x)
      var y = parseInt(this.texttool_y)

      var newY = y + (this.texttoolSize / 10)
      var weight = this.activefontweight
      // textarea.style.lineHeight = this.texttoolSize + 'px'
      if (textareatext !== '') {
        var textcount = this.highestArrayID('text') + 1
        this.maxlayerid = this.highestLayerID.id + 1
        this.layers.push({
          id: this.maxlayerid,
          visible: true,
          deleted: false,
          typ: 'text',
          count: textcount,
          name: 'Text Layer ' + textcount,
        })
        this.$nextTick(function () {
          this.setactivelayer(this.layers.length - 1, false)
          this.drawString(this.vueCanvas, textareatext, x, newY, this.texttoolColor, 0, this.fontfamily, this.texttoolSize, weight)
          this.historyPush('Type Tool')
          textarea.innerText = ''
        })
      }
      this.addtext = false
    },
    drawString (ctx, text, posX, posY, textColor, rotation, font, fontSize, fontweight) {
      var lines = text.split('\n')
      if (!rotation) rotation = 0
      if (!font) font = 'serif'
      if (!fontSize) fontSize = 16
      if (!textColor) textColor = '#000000'
      if (!fontweight) fontweight = ''
      ctx.save()
      ctx.globalCompositeOperation = 'source-over'
      ctx.textBaseline = 'top'
      ctx.font = fontweight + ' ' + fontSize + 'px ' + font
      ctx.fillStyle = textColor
      if (parseInt(this.texttoolStroke) !== 0) {
        ctx.strokeStyle = this.textstrokeColor
        ctx.lineWidth = this.texttoolStroke
      }
      ctx.translate(posX, posY)
      ctx.rotate(rotation * Math.PI / 180)
      for (var i = 0; i < lines.length; i++) {
        if (parseInt(this.texttoolStroke) !== 0) {
          ctx.strokeText(lines[i], 0, i * fontSize)
        }
        ctx.fillText(lines[i], 0, i * fontSize)
      }
      ctx.restore()
    },
    tooglefont (fontname) {
      this.fontfamily = fontname
    },
    movetexttool (e) {
      if (this.isDragging) {
        // var x = e.offsetX - this.down_x
        // var y = e.offsetY - this.down_y
        // var activeX = this.down_x
        // var activeY = this.down_y

        var xAdd = this.mousedownbeginX - e.offsetX
        var yAdd = this.mousedownbeginY - e.offsetY

        var newX = this.texttool_start_x - xAdd
        var newY = this.texttool_start_y - yAdd
        this.texttool_x = newX
        this.texttool_y = newY
      }
    },
    setcursorpos (e) {
      // var cursor = document.getElementById('custom-cursor')
      this.cursorleft = e.offsetX
      this.cursortop = e.offsetY
    },
    useselect (e) {
      if (this.isDragging) {
        var newX = this.canvas_x - this.mousedownbeginX
        var newY = this.canvas_y - this.mousedownbeginY
        if (newX < 0) {
          this.selecttool_x = this.mousedownbeginX + newX
          this.selecttool_w = Math.abs(newX)
        } else {
          this.selecttool_w = newX
        }
        if (newY < 0) {
          this.selecttool_y = this.mousedownbeginY + newY
          this.selecttool_h = Math.abs(newY)
        } else {
          this.selecttool_h = newY
        }
      } else {
        if (this.selecttool_w <= 0 || this.selecttool_h <= 0) {
          this.selecttoolactive = false
        }
      }
    },
    clearRectangle (ctx, posX, posY, width, height) {
      ctx.clearRect(posX, posY, width, height)
    },
    changestrokecolor (color) {
      this.shapeStroke = color.hex8
    },
    changefillcolor (color) {
      this.shapeFill = color.hex8
    },
    handleCancel (which) {
      if (which === 'CanvasSize') {
        this.modalcanvassize = false
        this.newframe_w = this.frameCanvas_w
        this.newframe_h = this.frameCanvas_h
      } else if (which === 'ImageImport') {
        this.modalimageimport = false
      }
    },
    getpixelcolour (e) {
      var c = this.$refs.layers[this.activelayer]
      var ctx = c.getContext('2d')
      var x = e.offsetX
      var y = e.offsetY
      /* if (this.zoomscale >= 1) {
            x = e.offsetX * this.zoomscale - 1
            y = e.offsetY * this.zoomscale - 1
          } else {
            x = parseInt(e.offsetX * this.zoomscale) + this.canvastranslate.x - 1
            y = parseInt(e.offsetY * this.zoomscale) + this.canvastranslate.y - 1
          } */
      var pixeldata = ctx.getImageData(x, y, 1, 1)
      return pixeldata.data
    },
    replacecol (e) {
      var col = this.getpixelcolour(e)
      var c = this.$refs.layers[this.activelayer]
      var ctx = c.getContext('2d')
      var maskCanvasPaddingX = (this.mainCanvas_w - this.frameCanvas_w) / 2
      var maskCanvasPaddingY = (this.mainCanvas_h - this.frameCanvas_h) / 2
      var CanvasWidth = this.frameCanvas_w
      var CanvasHeight = this.frameCanvas_h

      var newcolor = this.globalcolorone

      var color = newcolor.replace('#', '')
      const r = parseInt(color.substring(0, 2), 16)
      const g = parseInt(color.substring(2, 4), 16)
      const b = parseInt(color.substring(4, 6), 16)

      if (this.selecttoolactive) {
        maskCanvasPaddingX = this.selecttool_x
        maskCanvasPaddingY = this.selecttool_y
        CanvasWidth = this.selecttool_w
        CanvasHeight = this.selecttool_h
      }
      var pixels = ctx.getImageData(
        maskCanvasPaddingX, maskCanvasPaddingY, CanvasWidth, CanvasHeight
      )
      var all = pixels.data.length
      var data = pixels.data
      for (var i = 0; i < all; i += 4) {
        if (data[i] === col[0] && data[i + 1] === col[1] &&
          data[i + 2] === col[2] && data[i + 3] === col[3]) {
          data[i] = r
          data[i + 1] = g
          data[i + 2] = b
          data[i + 3] = 255
        }
      }
      ctx.putImageData(pixels, maskCanvasPaddingX, maskCanvasPaddingY)
      // ctx.drawImage(pixels, maskCanvasPaddingX, maskCanvasPaddingY)
    },
    createBSDFile () {
      var BSDArray = []
      var bsdLayers = []
      var DataUrl
      var LayerName
      var LayerID
      var LayerTyp
      var LayerVisible = true
      var LayerCount = 0

      var layerCopy = this.layers.slice()

      var Data
      var DBlob

      var CropCanvas = document.getElementById('resulttempcanvas')
      var CropCanvasContext = CropCanvas.getContext('2d')
      var sourceX = (this.mainCanvas_w - this.frameCanvas_w) / 2
      var sourceY = (this.mainCanvas_h - this.frameCanvas_h) / 2

      var sourceWidth = this.frameCanvas_w
      var sourceHeight = this.frameCanvas_h

      var destX = 0
      var destY = 0

      var destWidth = this.frameCanvas_w
      var destHeight = this.frameCanvas_h

      for (let i = 0; i < layerCopy.length; i++) {
        LayerID = layerCopy[i]['id']
        CropCanvasContext.clearRect(0, 0, this.frameCanvas_w, this.frameCanvas_h)
        var canvas = document.getElementById('canvas_' + i)
        CropCanvasContext.drawImage(canvas, sourceX, sourceY, sourceWidth, sourceHeight, destX, destY, destWidth, destHeight)
        DataUrl = CropCanvas.toDataURL()
        LayerName = layerCopy[i]['name']
        LayerTyp = layerCopy[i]['typ']
        LayerVisible = layerCopy[i]['visible']
        LayerCount = layerCopy[i]['count']

        // DataUrl = this.$refs.layers[i].toDataURL()
        bsdLayers.push({
          id: LayerID,
          visible: LayerVisible,
          imgdata: DataUrl,
          name: LayerName,
          typ: LayerTyp,
          count: LayerCount,
        })
        DataUrl = ''
      }

      BSDArray.push({
        projectname: this.projectname,
        frame_w: this.frameCanvas_w,
        frame_h: this.frameCanvas_h,
        layer: bsdLayers,
        activelayer: this.activelayer,
      })
      bsdLayers = null

      Data = JSON.stringify(BSDArray)
      DBlob = new Blob([Data], { type: 'text/plain' })
      return DBlob
    },
    downloadbsd () {
      var DBlob = this.createBSDFile()
      var link = document.createElement('a')
      link.download = this.projectname + '.bsd'
      link.href = window.URL.createObjectURL(DBlob)
      link.click()
      this.modalsaveproject = false
    },
    uploadbsd () {
      var File = this.createBSDFile()
      var Name = this.projectname + '.bsd'
      this.UploadtoBrez(File, Name)
      this.modalsaveproject = false
    },
    importBSDFile (file) {
      var importfile = file.file.originFileObj
      this.readBSDFile(importfile)
      this.modalopenfile = false
      // this.$refs.fileopenuploader.
    },
    readBSDFile (file, name) {
      if (!file) file = this.$refs.RefOpenFile.files[0]
      if (!name) name = file.name
      var projectArray = []
      // var content
      const reader = new FileReader()
      if (name.includes('.bsd')) {
        reader.onload = (res) => {
          // content = res.target.result
          projectArray = JSON.parse(res.target.result)
          this.OpenProject(projectArray)
        }
        reader.onerror = (err) => console.log(err)
        reader.readAsText(file)
      } else {
        // content = 'check the console for file output'
        reader.onload = (res) => {
          console.log(res.target.result)
        }
        reader.onerror = (err) => console.log(err)
        reader.readAsText(file)
      }
    },
    OpenProject (Arr) {
      this.projectArray = Arr
      this.layers = null
      var framew = Arr[0]['frame_w']
      var frameh = Arr[0]['frame_h']
      var pname = Arr[0]['projectname']
      var imgurl
      var layer
      var activelayerID
      if (!pname) { pname = 'New Project' } else { this.projectname = pname }

      // var LayerID
      if (!Arr[0]['activelayer']) {
        activelayerID = 0
      } else {
        activelayerID = Arr[0]['activelayer']
      }
      var islast = false

      this.frameCanvas_w = parseInt(framew)
      this.frameCanvas_h = parseInt(frameh)
      this.drawcanvasmask()
      this.resetZoom()

      this.layers = Arr[0]['layer'].slice()
      this.$nextTick(function () {
        for (let i = 0; i < this.layers.length; i++) {
          // LayerID = this.layers[i]['id']
          imgurl = this.layers[i].imgdata
          layer = document.getElementById('canvas_' + i)
          if ((i + 1) === this.layers.length) {
            islast = true
          }
          this.drawfunc(imgurl, layer, framew, frameh, islast)
        }
        this.setactivelayer(activelayerID)
      })
      this.showstartscreen = false
    },
    drawfunc (imgurl, layer, frameW, frameH, islast) {
      var maskCanvasPaddingX = (this.mainCanvas_w - frameW) / 2
      var maskCanvasPaddingY = (this.mainCanvas_h - frameH) / 2
      var c = layer
      var ctx = c.getContext('2d')
      var img = new Image()
      img.src = imgurl

      var vue = this
      ctx.clearRect(0, 0, this.mainCanvas_w, this.mainCanvas_h)
      img.onload = function () {
        ctx.drawImage(img, maskCanvasPaddingX, maskCanvasPaddingY)
        if (islast) {
          vue.projectloaded = true
        }
      }
    },
    updateGlobalColorOne (color) {
      this.globalcolorone = color.hex8
    },
    openBSDfromMedia () {
      Api.files().getFile(this.mediaimage.id).then(Response => {
        var FileName = this.mediaimage.name
        var FileExtension = this.mediaimage.name.split('.').pop()
        if (FileExtension === 'bsd') {
          Response.blob().then(blob => {
            this.readBSDFile(blob, FileName)
            this.modalopenfile = false
            console.log(Response)
            console.log(this.mediaimage)
          })
        } else {
          this.$message.error('The selected file is no .bsd file')
        }
      })
    },
  },
}

</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Architects+Daughter&family=Dancing+Script&family=Open+Sans&family=Roboto&display=swap');

#mainCanvas {
  z-index: 20;
}

#custom-cursor {
  position: absolute;
  box-shadow: 0px 0px 2px 0px #FFFFFF;
  left: 50%;
  top: 50%;
  border: 1px solid #111;
  transform: translate(-50%, -50%);
  border-radius: 100%;
  width: 5px;
  height: 5px;
  z-index: 30;
  pointer-events: none;
}

#selecttool {
  position: absolute;
  border: 1px dashed #444;
  z-index: 30;
  transform-origin: top left;
  pointer-events: none;
  box-shadow: 0px 0px 2px 0px #FFFFFF;
}

#texttool-position {
  position: absolute;
  z-index: 110;
  border: 1px dashed black;
  transform-origin: top left;
  vertical-align: top;
  margin: 0px;
  padding: 0px;
}

#texttool {
  background: rgb(255, 255, 255, 0);
  outline: 0;
  transform-origin: top left;
  display: inline-block;
  min-width: 10px;
  white-space: nowrap;
  transform-origin: top left;
  vertical-align: top;
  margin: 0px;
  padding: 0px;
  position: relative;
}

#texttool pre {
  white-space: pre-wrap;
  background: #EEE;
}

.texttoolcopybox {
  position: absolute;
  top: 0px;
  left: 0px;
}

#boundingbox {
  position: absolute;
  z-index: 110;
  border: 2px dotted #ccc;
  pointer-events: none;
}

.control {
  width: 8px;
  height: 8px;
  border-radius: 100%;
  position: absolute;
  background: #555;
}

#tl-control {
  left: -5px;
  top: -5px;
  cursor: nw-resize;
  pointer-events: auto;
}

#tr-control {
  right: -5px;
  top: -5px;
  cursor: ne-resize;
  pointer-events: auto;
}

#bl-control {
  left: -5px;
  bottom: -5px;
  cursor: sw-resize;
  pointer-events: auto;
}

#br-control {
  right: -5px;
  bottom: -5px;
  cursor: se-resize;
  pointer-events: auto;
}

#rotate-control {
  width: 8px;
  height: 8px;
  border-radius: 100%;
  position: absolute;
  background: #555;
  top: -30px;
  left: 50%;
  margin-left: -4px;
  cursor: crosshair;
  pointer-events: auto;
}

#east-control {
  position: absolute;
  border-radius: 0px;
  background: none;
  border: 2px solid #555;
  right: -5px;
  top: 50%;
  margin-top: -4px;
  cursor: w-resize;
  pointer-events: auto;
}

#west-control {
  position: absolute;
  border-radius: 0px;
  background: none;
  border: 2px solid #555;
  left: -5px;
  top: 50%;
  margin-top: -4px;
  cursor: e-resize;
  pointer-events: auto;
}

#south-control {
  position: absolute;
  border-radius: 0px;
  background: none;
  border: 2px solid #555;
  left: 50%;
  bottom: -5px;
  margin-left: -4px;
  cursor: n-resize;
  pointer-events: auto;
}

#north-control {
  position: absolute;
  border-radius: 0px;
  background: none;
  border: 2px solid #555;
  left: 50%;
  top: -5px;
  margin-left: -4px;
  cursor: s-resize;
  pointer-events: auto;
}

.drawingcanvas-wrapper {
  width: 100%;
  position: relative;
  padding: 10px;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  z-index: 1;
}

.modalmediamanger {
  max-height: 500px;
  overflow-y: scroll;
  margin-top: 10px;
}

.modalimageexport .export-container {
  display: flex;
}

.modalimageexport .export-container .left {
  flex-grow: 4;
}

.modalimageexport .export-container .right {
  padding: 0px 0px 0px 20px;
}

.modalimageexport .export-container .right .colorbutton {
  border: 1px solid #d9d9d9;
  width: 24px;
  height: 24px;
  margin: 5px 0px;
  border-radius: 2px;
}

.modalimageexport .export-container .right .current-color {
  width: 14px;
  height: 14px;
  display: block;
  border: 1px solid #d9d9d9;
}

.modalimageexport #exportimage-preview {
  max-width: 400px;
  max-height: 400px;
}

.modalimageexport #exportimage-preview #result-imageY {
  max-width: 400px;
  height: auto;
  max-height: 400px;
  border: 1px solid #ccc;
}

.modalimageexport .export-result-wrapper {
  background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAAXNSR0IB2cksfwAAAAZQTFRF////yMjIXOIDQgAAABJJREFUeJxjYPjPgBXhEB7uAABycQ/xMT/uAgAAAABJRU5ErkJggg==');
  background-size: auto;
  background-repeat: repeat;
  display: inline-flex;
}

.dc-drawing-canvas #canvasmask {
  z-index: 100;
}

.dc-drawing-canvas canvas img {
  image-rendering: optimizeSpeed;
  image-rendering: -moz-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: optimize-contrast;
  image-rendering: pixelated;
  -ms-interpolation-mode: nearest-neighbor;
  border: 5px solid #ddd;
}

.canvas-background {
  background: #eee;
  width: 800px;
  height: 800px;
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: -1;
}

.canvas-frame-background {
  background: #fff;
  height: 800px;
  width: 800px;
}

.drawingcanvas-wrapper .dc-options-top {
  width: 100%;
  margin-bottom: 10px;
  background: #f6f6f6;
  border: 1px solid rgb(232, 232, 232);
}

.drawingcanvas-wrapper .dc-options-top .undoredo {
  margin: 0px 10px;
}

.drawingcanvas-wrapper .dc-options-top .undoredo button {
  padding: 5px 5px;
  border: 0px;
  background: none;
  border-radius: 10px;
}

.drawingcanvas-wrapper .dc-options-top .undoredo button:hover {
  background: rgb(0, 0, 0, 0.1)
}

.drawingcanvas-wrapper .dc-options-top .undoredo button svg {
  width: 24px;
  height: 24px;
}

.drawingcanvas-wrapper .dc-options-top .dc-brush {
  display: flex;
  align-items: center;
  height: 50px;
}

.drawingcanvas-wrapper .dc-options-top .dc-brush .brush-size {
  display: flex;
  align-items: center;
}

.drawingcanvas-wrapper .dc-options-top .dc-brush .brush-size input {
  width: 80px;
}

.drawingcanvas-wrapper .dc-options-top .dc-brush .brush-size .inp_number {
  width: 45px;
  border: 1px solid #ccc;
  margin: 0px 10px;
}

.drawingcanvas-wrapper .dc-options-top .dc-brush .brush-size {
  margin: 0px 10px;
}

.drawingcanvas-wrapper .dc-options-top .dc-brush .icon {
  width: 20px;
  height: 20px;
  margin: 0px 10px 0px 10px;
  position: relative;
}

.drawingcanvas-wrapper .dc-options-top .dc-brush .brush-options {
  position: relative;
  margin: 0px 10px 0px 10px;
}

.drawingcanvas-wrapper .dc-options-top .dc-brush .brush-options button {
  padding: 5px 5px;
  border: 0px;
  background: none;
  border-radius: 10px;
  position: relative;
}

.drawingcanvas-wrapper .dc-options-top .dc-brush .brush-options button:hover {
  background: rgb(0, 0, 0, 0.1)
}

.drawingcanvas-wrapper .dc-options-top .dc-brush .brush-options button img {
  width: 24px;
  height: 24px;
}

.drawingcanvas-wrapper .dc-options-top .dc-brush .brush-options button span {
  position: absolute;
  right: 0px;
  bottom: 0px;
}

#brush-options-case .inp_number {
  width: 45px;
  background: rgb(100, 100, 100, 0.2);
  border-radius: 2px;
  border: 1px solid #ccc;
  margin: 0px 10px;
  float: right;
  margin: 0px 0px 10px 0px;
}

#brush-options-case input[type=range] {
  display: block;
}

#erase-options-case .inp_number {
  width: 45px;
  background: rgb(100, 100, 100, 0.2);
  border-radius: 2px;
  border: 1px solid #ccc;
  margin: 0px 10px;
  float: right;
  margin: 0px 0px 10px 0px;
}

#erase-options-case input[type=range] {
  display: block;
}

.drawingcanvas-wrapper .dc-options-top .erase-options {
  position: relative;
  margin: 0px 10px 0px 10px;
}

.drawingcanvas-wrapper .dc-options-top .erase-options button {
  padding: 5px 5px;
  border: 0px;
  background: none;
  border-radius: 10px;
  position: relative;
}

.drawingcanvas-wrapper .dc-options-top .erase-options button:hover {
  background: rgb(0, 0, 0, 0.1)
}

.drawingcanvas-wrapper .dc-options-top .erase-options button img {
  width: 24px;
  height: 24px;
}

.drawingcanvas-wrapper .dc-options-top .erase-options button span {
  position: absolute;
  right: 0px;
  bottom: 0px;
}

.drawingcanvas-wrapper .dc-options-top .shape-options {
  position: relative;
  margin: 0px 10px 0px 10px;
}

.drawingcanvas-wrapper .dc-options-top .shape-options button {
  padding: 5px 5px;
  border: 0px;
  background: none;
  border-radius: 10px;
  position: relative;
}

.drawingcanvas-wrapper .dc-options-top .shape-options button:hover {
  background: rgb(0, 0, 0, 0.1)
}

.drawingcanvas-wrapper .dc-options-top .shape-options button img {
  width: 24px;
  height: 24px;
}

.drawingcanvas-wrapper .dc-options-top .shape-options button span {
  position: absolute;
  right: 0px;
  bottom: 0px;
}

#shape-options-case .shapes-wrapper {
  display: flex;
}

#shape-options-case .shapes-wrapper .shape {
  width: 50px;
  min-height: 50px;
  padding: 0px 0px;
  margin: 1px;
  background: rgb(0, 0, 0, 0.1);
  text-align: center;
  vertical-align: middle;
}

#shape-options-case .shapes-wrapper .shape .shapes-thumb {
  height: 40px;
  padding: 5px 0px 0px 0px;
}

#shape-options-case .shapes-wrapper .shape .shapes-thumb path {
}

#shape-options-case .shapes-wrapper .shape.active {
  border: 1px solid rgb(24, 144, 255, 0.5);
  background: rgb(24, 144, 255, 0.1);
}

.drawingcanvas-wrapper .dc-options-top .dc-brush .icon.brush {
  background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgBAMAAAB54XoeAAAAHlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC3KG9qAAAACnRSTlMA/hKxffA311BeudL+agAAA9hJREFUeJytm81v00AQxa00pOlxCSZwM6KoVxYC5ZiAEOVGQAKOLjduuBVwDRJwJv8xiZ00/thZv3m7c0sl/zS78/btetZNkoAYnU9fhjzfiYUx6Soi78hsYpLFAy62QPM5Gm+wLIHmSSzgUcUz0zwS8HIHNHciAe0eGGnQ4xteJO0cH4BxBr2oAc1VOG8vmmiDHppGTIKBD5rA8EHbFjB00CPTjsBKH3eAgfJed4FpHgIsusCgQQ8dvKBBP3ICA4ysLZpd0O7dFc0u5iTwSAKydbmUgGbFAQsR+I3inYg8c5cCukUTMIkLGUj5YtOsIwBF0bBAWTTkHFoPkKny2MMzjwmgw6wPkRNAj2jMfYLnEw3lNm6zroKqsWfdcXZoIycomjWboGfdMSVOkl8y8B8FLCIn6BENl6AsmnsUT1535PlwICb4kUtQFA17lhPNmkxQFE2acTxxh2ffAc4E3pRMUBQNm6Bk1nTfQRINfbYWRMM3RqwbyOzFZQjrjn8RFYB0gkniLHLI+5NzDucBQFeVg95qXcckzvi/vvq+fdCxJ1PGf/rM7AyvM4mM8Q/elI+WhtJxG8JXT/ZZbeXWHjNh/KfLRjnXoQkeeNV7YXOf1/tqnVelE9bxGhedfIbtP2hiYE0jrlopqn31daumpZGOl42fmnho2lEa1VnjlyJGyw6wymk3aLWvurbMctZG1dTOlTznDlfVdbRd21rbald4F1WnZ/D7/FqboHToYLfgQSEAU85QxQTZhpmY4CYmDLGr6UCi9QEJou+VuJxHbWXWPUCT6i7LHKu4Q3yuAcqaqUWmANrIQG+j5yZyHOjrUlBAaMSKZquvS1ELXIq+7iAF9HUHKaCNDASnEC8KOIU4EFOhQoe+diMFLEBgBvLQmhg0wT6z3keKAr0t4FpMUSC4TvCzF1pk+KxURAbKzbJWoD1/z+VQM26DQHQlm3cg8BYKRE/s7YtyMeYgEFUN7A0WBWYgsAB56EKBZYjqGpYhqmvUvOA7VdS8YNXAMsxBIOqGsL1Gd0MLAlGvgXWNWgOs6xwEYqdrxQ6F6hru8aF+DfdDUF3nKBDUNd5gAXX9HgZaDDiHgUuIBy9k9GyIfygAyhAfMSZDRRMNOzYo+qSeq+NDaDrNkAw1vfolApzjPEg1mrYhVGRFgtBbnqqvCdREd9tR9AN/aHjAQUnXyO0/1yibm71TqGy/er/LKXnK7+H7VKj+vr5ng5qslLyeEc8yJc8/4gnx7wRWxqUv1On5tpPpLNfjZBFeXxDZJdIMfph9oWjOy5NPswuWtok/ddLPp7O3fzOa9R+zT4BdqVJm+AAAAABJRU5ErkJggg==') center center no-repeat;
  background-size: contain;
}

.drawingcanvas-wrapper .dc-options-top .dc-brush .more {
  position: relative;
}

.drawingcanvas-wrapper .dc-options-top .dc-brush .more span {
  position: absolute;
  right: -6px;
  bottom: -6px;
  margin: 0px;
  padding: 0px;
}

.drawingcanvas-wrapper .dc-options-top .dc-brush .colors {
  display: flex;
  position: relative;
}

.drawingcanvas-wrapper .dc-options-top .dc-brush .colors #activeColor {
  position: relative;
  width: 30px;
  height: 30px;
  margin: 2px;
  border: 1px solid #000;
  border-radius: 3px;
}

.drawingcanvas-wrapper .dc-options-top .dc-brush .colors #color-options-case {
  position: absolute;
  left: 0px;
  top: 40px;
  background: #f6f6f6;
  border: 0px solid #ccc;
  z-index: 110;
  padding: 0px;
  border-radius: 5px;
  display: flex;
  flex-wrap: wrap;
}

.drawingcanvas-wrapper .dc-options-top .color-options-case {
  position: absolute;
  left: 0px;
  top: 40px;
  background: #f6f6f6;
  border: 1px solid #ccc;
  z-index: 110;
  padding: 10px;
  border-radius: 5px;
  display: flex;
  flex-wrap: wrap;
  min-width: 250px;
}

.drawingcanvas-wrapper .dc-options-top .color-options-case .color {
  width: 20px;
  height: 20px;
  margin: 2px;
  border: 1px solid #000;
}

.drawingcanvas-wrapper .dc-options-top .color-options-case .no-color {
  width: 20px;
  height: 20px;
  padding: 0px;
  color: #ff0000;
  margin: 2px;
  border: 1px solid #000;
  text-align: center;
}

.drawingcanvas-wrapper .dc-options-top .color-options-case .color-hex {
  width: 100%;
  margin: 10px 0px;
}

.drawingcanvas-wrapper .dc-options-top .color-options-case input {
  width: 70px;
  background: rgb(100, 100, 100, 0.2);
  border-radius: 2px;
  border: 1px solid #ccc;
}

.drawingcanvas-wrapper .dc-options-top .dc-brush .colors .active-color {
  border: 1px solid rgb(24, 144, 255, 1)
}

.drawingcanvas-wrapper .dc-options-top .shape-fill-color {
  display: flex;
  position: relative;
}

.drawingcanvas-wrapper .dc-options-top .shape-fill-color #shape-fill-active.emptycolor {
  background: none;
  overflow: hidden;
  color: #ff0000;
  padding: 0px;
}

.drawingcanvas-wrapper .dc-options-top .shape-fill-color #shape-fill-active.emptycolor svg {
  width: 30px;
  height: 30px;
}

.drawingcanvas-wrapper .dc-options-top .shape-fill-color #shape-fill-active {
  width: 30px;
  height: 30px;
  margin: 2px;
  border: 1px solid #000;
  border-radius: 3px;
}

.drawingcanvas-wrapper .dc-options-top .shape-fill-color #shape-stroke-active {
  width: 30px;
  height: 30px;
  margin: 2px;
  border: 1px solid #000;
  border-radius: 3px;
  position: relative;
}

.drawingcanvas-wrapper .dc-options-top .shape-fill-color #shape-stroke-active div {
  width: 16px;
  height: 16px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -8px;
  margin-top: -8px;
  background: #f6f6f6;
  border: 1px solid #000;
}

.drawingcanvas-wrapper .dc-options-top .shape-stroke {
  margin: 0px 10px;
  vertical-align: middle;
  position: relative;
}

.drawingcanvas-wrapper .dc-options-top .shape-stroke label {
  margin-right: 10px;
  font-size: 13px;
}

.drawingcanvas-wrapper .dc-options-top .shape-stroke .inp_number {
  width: 45px;
  background: rgb(100, 100, 100, 0.2);
  border-radius: 2px;
  border: 1px solid #ccc;
  padding: 4px;
  margin: 0px;
}

.drawingcanvas-wrapper .dc-options-top .shape-stroke button {
  padding: 5px 5px;
  border: 0px;
  background: none;
  position: relative;
}

.drawingcanvas-wrapper .dc-options-top .shape-stroke button:hover {
  background: rgb(0, 0, 0, 0.1)
}

.drawingcanvas-wrapper .dc-options-top .shape-stroke button span {
  width: 24px;
  height: 24px;
}

.drawingcanvas-wrapper .dc-options-top .shape-stroke #stroke-options-case {
  position: absolute;
  left: 0px;
  top: 40px;
  background: #f6f6f6;
  border: 1px solid #ccc;
  z-index: 110;
  padding: 10px;
  border-radius: 5px;
  display: flex;
  flex-wrap: wrap;
}

.drawingcanvas-wrapper .dc-options-top .shape-stroke #stroke-options-case input {
  width: 100px;
}

.drawingcanvas-wrapper .dc-options-top .texttool-menu .inp_number {
  width: 55px;
  background: rgb(100, 100, 100, 0.2);
  border-radius: 2px;
  border: 1px solid #ccc;
  padding: 4px;
  margin: 0px;
}

.drawingcanvas-wrapper .dc-options-top .texttool-menu .btn-arrowdown {
  padding: 5px 5px;
  border: 0px;
  background: none;
  position: relative;
}

.drawingcanvas-wrapper .dc-options-top .texttool-menu .btn-arrowdown:hover {
  background: rgb(0, 0, 0, 0.1);
}

.drawingcanvas-wrapper .dc-options-top .texttool-menu label {
  margin-right: 10px;
  font-size: 13px;
}

.drawingcanvas-wrapper .dc-options-top .texttool-menu input[type=color] {
  width: 28px;
  height: 30px;
  padding: 0px;
  border: 1px solid #ccc;
  margin-right: 10px;
  vertical-align: middle;
}

.drawingcanvas-wrapper .dc-options-top .texttool-font {
  position: relative;
  margin: 0px 10px 0px 10px;
}

.drawingcanvas-wrapper .dc-options-top .texttool-font button {
  padding: 5px 5px;
  border: 0px;
  background: none;
  border-radius: 10px;
  position: relative;
}

.drawingcanvas-wrapper .dc-options-top .texttool-font button:hover {
  background: rgb(0, 0, 0, 0.1)
}

.drawingcanvas-wrapper .dc-options-top .texttool-font button img {
  width: 24px;
  height: 24px;
}

.drawingcanvas-wrapper .dc-options-top .texttool-font button span {
  position: absolute;
  right: 0px;
  bottom: 0px;
}

.drawingcanvas_dropdownmenu {
  background: #f6f6f6;
  border: 1px solid #ccc;
}

.drawingcanvas_dropdownmenu .drawingcanvas_fonts {
  max-height: 300px;
  overflow-y: scroll;
}

.drawingcanvas_dropdownmenu .drawingcanvas_fonts ul {
  list-style: none;
  margin: 0px;
  padding: 0px;
}

.drawingcanvas_dropdownmenu .drawingcanvas_fonts ul li:first-child {
  border-top: 0px solid #ccc;
}

.drawingcanvas_dropdownmenu .drawingcanvas_fonts ul li {
  padding: 4px 10px;
  border-top: 1px solid #777;
}

.drawingcanvas_dropdownmenu .drawingcanvas_fonts ul li .preview {
  float: right;
  margin-left: 20px;
}

.drawingcanvas_dropdownmenu .drawingcanvas_fonts ul li.active {
  background: rgb(24, 144, 255, 0.4)
}

.drawingcanvas_dropdownmenu .drawingcanvas_fonts ul li.active:hover {
  background: rgb(24, 144, 255, 0.4)
}

.drawingcanvas_dropdownmenu .drawingcanvas_fonts ul li:hover {
  background: rgb(0, 0, 0, 0.1);
  cursor: pointer;
}

.drawingcanvas_dropdownmenu.fontsize {
  background: #fff;
  padding: 10px;
}

.drawingcanvas-wrapper .dc-options-top .texttool-confirm {
  position: relative;
  margin: 0px 20px 0px 20px;
}

.drawingcanvas-wrapper .dc-options-top .texttool-confirm button {
  padding: 5px 5px;
  border: 0px;
  background: none;
  border-radius: 10px;
  position: relative;
  vertical-align: middle;
  display: inline-flex;
}

.drawingcanvas-wrapper .dc-options-top .texttool-confirm button:hover {
  background: rgb(0, 0, 0, 0.1)
}

.drawingcanvas-wrapper .dc-options-top .texttool-confirm button img {
  width: 20px;
  height: 20px;
}

.drawingcanvas-wrapper .dc-options-top .toolbuttons {
  display: flex;
}

.drawingcanvas-wrapper .dc-options-top .toolbuttons button {
  padding: 5px 5px;
  margin: 0px 1px;
  border: 0px;
  background: none;
  border-radius: 10px;
  position: relative;
  vertical-align: middle;
  display: inline-flex;
}

.drawingcanvas-wrapper .dc-options-top .toolbuttons button:hover {
  background: rgb(0, 0, 0, 0.1)
}

.drawingcanvas-wrapper .dc-options-top .toolbuttons button img {
  width: 22px;
  height: 22px;
}

.drawingcanvas-wrapper .dc-options-top .toolbuttons button.active {
  background: rgb(0, 0, 0, 0.1)
}

.drawingcanvas-wrapper .dc-options-top .toolbuttons .colorbutton {
  position: relative;
  width: 30px;
  height: 30px;
  margin: 2px 8px 2px 2px;
  border: 1px solid #000;
  border-radius: 3px;
}

.drawingcanvas-wrapper .dc-options-top .toolbuttons .colorbutton .colorinner {
  width: 20px;
  height: 20px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -10px;
  margin-top: -10px;
  background: #f6f6f6;
  border: 1px solid #000;
}

.drawingcanvas-wrapper .dc-options-top .toolbuttons .toolicon img {
  width: 22px;
  height: 22px;
}

.drawingcanvas-wrapper .dc-options-top .toolbuttons .toolicon {
  padding: 5px 5px;
  margin: 0px 10px 0px 10px;
}

.drawingcanvas-wrapper .dc-options-top .toolbuttons.fontweight {
  margin-left: 10px;
}

.drawingcanvas-wrapper .dc-options-top .dc-brush .brush-size {
}

.drawingcanvas-wrapper .dc-options-top .brush-menu #ruler-horizontal.active {
  background: rgb(0, 0, 0, 0.1)
}

.drawingcanvas-wrapper .dc-options-top .brush-menu #ruler-horizontal:hover {
  background: rgb(0, 0, 0, 0.1)
}

.drawingcanvas-wrapper .dc-options-top .brush-menu #ruler-horizontal {
  padding: 5px 7px 4px 7px;
  border: 0px;
  background: none;
  border-radius: 10px;
  height: 34px;
}

.drawingcanvas-wrapper .dc-options-top .brush-menu #ruler-horizontal img {
  width: 20px;
  height: 20px;
}

.drawingcanvas-wrapper .dc-options-top .brush-menu #ruler-vertical.active {
  background: rgb(0, 0, 0, 0.1)
}

.drawingcanvas-wrapper .dc-options-top .brush-menu #ruler-vertical:hover {
  background: rgb(0, 0, 0, 0.1)
}

.drawingcanvas-wrapper .dc-options-top .brush-menu #ruler-vertical {
  padding: 8px 9px 2px 9px;
  border: 0px;
  background: none;
  border-radius: 10px;
  height: 34px;
}

.drawingcanvas-wrapper .dc-options-top .brush-menu #ruler-vertical img {
  width: 18px;
  height: 18px;
}

.dc-drawing-canvas {
  position: relative;
  background: #eee;
  transform-origin: top left;
  margin: auto;
}

.canvas-helper-wrapper {
  position: relative;
  flex-grow: 2;
  height: 500px;
  overflow: scroll;
  scroll-snap-align: center;
  z-index: 1;
}

.startscreenmask {
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgb(0, 0, 0, 0);
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 20;
  text-align: center;
  cursor: not-allowed;
}

.startscreenmask #startscreen {
  width: 400px;
  height: 400px;
  background: #eee;
  position: relative;
  top: 65%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: default;
}

.startscreenmask #startscreen h2 {
  font-size: 2rem;
}

.resolution-box {
  position: absolute;
  bottom: 0px;
  left: 0px;
}

.dc-drawing-canvas canvas {
  position: absolute;
  left: 0;
  top: 0;
}

.drawingcanvas-wrapper .dc-inner-wrapper .dc-menu-bar a {
  padding: 10px 20px;
  color: #333;
}

.drawingcanvas-wrapper .dc-inner-wrapper .dc-menu-bar {
  display: flex;
}

.drawingcanvas-wrapper .dc-inner-wrapper .dc-menu-bar {
  background: #f2f2f2;
  margin-bottom: 5px;
  border: 1px solid rgb(232, 232, 232);
  width: 100%;
  z-index: 2;
}

.drawingcanvas-wrapper .dc-inner-wrapper {
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
}

.drawingcanvas-wrapper .dc-inner-wrapper .workspace {
  display: flex;
  width: 100%;
}

.drawingcanvas-wrapper .dc-inner-wrapper .dc-options-left {
  margin-right: 10px;
}

.drawingcanvas-wrapper .dc-inner-wrapper .dc-options-right {
  margin-left: 10px;
}

.drawingcanvas-wrapper .dc-inner-wrapper .dc-options-left .option-item {
  width: 150px;
  border: 1px solid #ccc;
  padding: 20px;
  margin-top: 5px;
}

.drawingcanvas-wrapper .dc-inner-wrapper .dc-options-left .option-item:hover {
  border: 1px solid #1890ff;
  cursor: pointer;
}

.drawingcanvas-wrapper .dc-inner-wrapper .dc-options-left .add-screw-head {
  margin-top: 0px;
}

.drawingcanvas-wrapper .dc-inner-wrapper .dc-options-left .globalcolor-case { /* Del */
  display: none;
  background: #f6f6f6;
  margin-top: 10px;
  max-width: 80px;
  width: 40px;
  padding: 5px 5px 0px 0px;
  padding: 5px;
  border: 1px solid rgb(232, 232, 232);
}

.drawingcanvas-wrapper .dc-inner-wrapper .dc-options-left .globalcolor-case .color-one {
  width: 20px;
  height: 20px;
}

.drawingcanvas-wrapper .dc-inner-wrapper .dc-drawing-canvas {
  padding: 0px;
  border: 0px;
}

.dc-history-view {
  border: 1px solid #aaa;
  margin: 0px 0px 0px 0px;
  min-width: 140px;
  background: #f6f6f6;
  border: 1px solid rgb(232, 232, 232);
}

.dc-history-view .box-headline {
  width: 100%;
  padding: 2px 10px;
  font-weight: bold;
  border-bottom: 1px solid rgb(232, 232, 232);
  background: rgb(232, 232, 232, 0.5);
}

.dc-history-view .history-wrapper {
  overflow-y: scroll;
  max-height: 300px;
  height: 150px;
}

.dc-history-view .history-wrapper ul {
  margin: 0px;
  padding: 0px;
  list-style: none;
}

.dc-history-view .history-wrapper .step {
  padding: 2px 6px;
  border-bottom: 1px solid rgb(232, 232, 232);
}

.dc-history-view .history-wrapper .active {
  background: rgb(0, 0, 0, 0.1);
  color: #111;
}

.dc-history-view .history-wrapper .step span.past {
  color: #111;
}

.dc-history-view .history-wrapper .step span {
  font-size: 12px;
  color: #ccc;
}

.dc-navigator-view {
  border: 1px solid #aaa;
  margin: 0px 0px 20px 0px;
  min-width: 130px;
  background: #f6f6f6;
  border: 1px solid rgb(232, 232, 232);
}

.dc-navigator-view .box-headline {
  width: 100%;
  padding: 2px 10px;
  font-weight: bold;
  border-bottom: 1px solid rgb(232, 232, 232);
  background: rgb(232, 232, 232, 0.5);
}

.dc-navigator-view .navigator-wrapper {
  padding: 10px 5px;
  display: flex;
}

.dc-navigator-view .navigator-wrapper .inp_number {
  width: 50px;
  border: 1px solid #ccc;
  margin: 0px 0px;
  background: rgb(100, 100, 100, 0.2);
  border-radius: 2px;
  border: 1px solid #ccc;
}

.dc-navigator-view .navigator-wrapper .inp_range {
  width: 80px;
  margin: 0px 4px 0px 0px;
}

.dc-layers-view {
  border: 1px solid #aaa;
  margin: 0px 0px 0px 0px;
  min-width: 140px;
  background: #f6f6f6;
  border: 1px solid rgb(232, 232, 232);
}

.dc-layers-view .box-headline {
  width: 100%;
  padding: 2px 10px;
  font-weight: bold;
}

.dc-layers-view .layers-wrapper {
  overflow-y: scroll;
  max-height: 300px;
  height: 150px;
}

.dc-layers-view .layers-wrapper ul {
  display: flex;
  flex-direction: column-reverse;
}

.dc-layers-view .layer-options {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid rgb(232, 232, 232);
  padding: 2px;
}

.dc-layers-view .btn-left {
  justify-content: flex-start;
}

.dc-layers-view .btn-left {
  justify-content: flex-end;
}

.dc-layers-view .layer-options button {
  border-radius: 5px;
  box-sizing: border-box;
  padding: 4px;
  background: #f6f6f6;
  border: 0px solid #555;
}

.dc-layers-view .layer-options button:hover {
  background: rgb(100, 100, 100, 0.1);
  cursor: pointer;
}

.dc-layers-view .layer-options button img {
  width: 15px;
  height: 15px;
  display: block;
}

.dc-layers-view ul {
  margin: 0px;
  padding: 0px;
  list-style: none;
}

.dc-layers-view li {
  padding: 0px;
  font-size: 12px;
  border-top: 1px solid rgb(232, 232, 232);
}

.dc-layers-view li div {
  cursor: pointer;
  display: flex;
  padding: 4px 4px;
}

.dc-layers-view li div.active {
  background: rgb(24, 144, 255, 0.5)
}

.dc-layers-view li .locked {
  width: 15px;
  height: 15px;
  display: block;
  margin: 3px 10px 3px 10px;
  Background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAgMAAAAhHED1AAAAAXNSR0IB2cksfwAAAAxQTFRFAAAAAAAAAAAAAAAANek3lgAAAAR0Uk5T/wDMOCLbQLcAAANmSURBVHic7duxbhpBEAbgjV0BovQjuHFkpaK0lJcguECGR0hJEQVegp4yIopSXRmJl7ieMi+A5CYhgvh2Z2b/3b1l45goM5057+ed2dkDe89mGIvJz/Vq/Xkf+xYTuzhfmWN8rU8DPi7MU7wOCxFgYsfHhDAw2hoSX/KBRzreXOxygYcFA0wvF9gaEd/ygAc53vTqLMCbgDFVDuBPIFSFAPAIADwFDIwWCLhtD8zQeHNRtwZACUM5QGCCx8MyQgBngHOAQCADmAMC8Bocot8OGIfGoxwQEMwA5QCAcAaolwCA9kET/kICILSIuAgAiJQAFAEAkRKAIvjAu9h4vwg+EO6CYxHSwPsoYOoksI0DgxQQa6NDyCp6gKzhzZp/LavoAbyG3X093H+nr8gqegDrw+7umBUT6gQwpT9t91SXLXmxSgAbVDC6v67jAF2ErpstSULclSRAF4GsGJmCWAYJkEVgW9dV4TIO3MMJ0CmIW4IEyE6o6OukNnHATVXkOsOwB7hVFE3vcuDrKIFF4AeRHLgsgFGoViQ53ggCcG3g3btm+IoAXBt4d09bBN4IAnBtUEnAFoFvaAHYeYK3UVsEdkkAto/AhxGLLyPAFJf6GLY+VQSwfSR2/SHsCg3aANXQC1tFhgvAtlvtA1ZnK8wB24jeO9ghmgKx+gQA+MF6lgZsnToIGKOLAQB+rm6amfUyB+xSg1V0CbYBBqXAEgHNIrMl4oDdjDUENq0B+KuF24/0KgeazQj7yHVSGhDvPvLyycCsNQAb0ZVoeSowTgJNlcD96F8D4F5ym7UYuCoFBi8OFKdQDCyfD9iCKmUBiz8FXMUB6iuggAIKKKCAAs8IzD+ZdnHzAwL0cC4R5OCMAPBkJxBvAJD6YyqfQu0DsT+p+3HrA9ssoOcBWRmQHCwQO1VAUUkgrwSuCBaYZgIdCWwygUsBZNbQVdECmePtr68NkLsIdhkaIH6ugWLAgfv0CBHXHEgcjIDonxswzQY65wa8/fvAKwUUUEABBRRQQAEFFFBAAQUUUEABBRRQQAEFFFBAgf8POLtjomLg5Q/rioHiE8/iM9fiU9/ic+fik+/is/fsdexLoPj5g+InIIqfwSh+CmT4IQu484HiJ2GKn8UZTlatx//+p0EJDOfr9NBjrMnzSL8AZdCrydT7HRoAAAAASUVORK5CYII=') center center no-repeat;
  background-size: contain;
}

.dc-layers-view li .eye {
  width: 15px;
  height: 15px;
  display: block;
  margin: 5px 20px 5px 5px;
  background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4BAMAAADLSivhAAAAElBMVEUAAAAAAAAAAAAAAAAAAAAAAADgKxmiAAAABnRSTlMA\/\+SYFU6oDnW5AAADSElEQVR4nO1YS5biMAzM6wkHyIc9JMw\+aWCfHpo9DHD\/q0w\+2CrJsmOYVb8XrcBxSSXJsi0nySKLLPITJP1\+PO7dO8jzvspGyevj\/TWbt22GUh\/jCZw4dLQfCU\/\/OtARHkN\+1arYXn7PGl\+5lK0Ul\/exPfUgOvVyfqIPAfAMNojW4xzH\/Nc81otOg8GyUnQa\+BqFzbL1u6RHUYLWRoNdt\/9EY3u334uWTvwVwz1xHvGXDPcVFhHqqvIpxZi1CrX9vd\+PPj1gSPbK\/TrsO\/6NAU1fHbPDphMsbjItZ417BituR48NuAzXtPaHAq0NqHY82Omsp\+U3aDyQ\+YNE5zrri0nAGlgVzhbVaKwPdvCCWWxk\/KaQfSljgyvT\+v\+w48LIFDLG51lvaf\+z5GugkwWwec6TpEcrG6vG\+MjdxpCMYkr16oLXzrLphMsNJEDQHnLDiQsuZtGt6A8Ru8gjpeRZNst9REzhvDJW0kfF8NOVYQXC\/lQ6qekQbOtsMjeYJsOTala9DYBpV3zqLx54fBVOIZQAbiSYS5FI0\+tEfNRKZZLcUZwTeBcHxoATuCOwhu2nOqbtRDz9guAPGDE\/GgCHaGPqDZgdIUEwZMuA2ZndamCbjdX\/gOmz\+cVoXzUwqbeVaSdiwL40cGk\/W952IvJWT81GAZuJyFs5\+fBsI9p2k9qEc5XT15aGzE\+8p1xdMLlleRUwEY57xWly2YazhIkQstQF25DQ8mxgIobM4U2aiVUH\/mNFO7yVbaZgkUfTLccWitodz6rfNBkmhy7citdrJU\+GDB1BYBqPFrihk85SamNr1KYELsmwcM0gGQHT9hKH3RgZtiGk6LCbeH993Oash4UwbuwgFYLWQpAQRXAQTu3GD8VpuJa3mkopeK1A90CnbCE00tw7bDJ2Hiyet7zDwbuK3m6eYIYIK5pWG0Z2j5ITULGCZlg3ny2iJXP2hKEkhO\+3\/HHjxr5pEeX3u4IeN868yVFzKe\/j9fH\+nXyfZX\/k6b\/DjxVGfO8Gp3kobwWZzL856G1\/HDqETVJf9zhJ\+JEmjJ7BBpnPPS0NcvNg65C\/Vs6tRvkYA03cV8BMrvVX4PkxwltOfv9ZbbOqqvevPV4ussgiP1L\+AQ8hBe9YslSuAAAAAElFTkSuQmCC') center center no-repeat;
  background-size: contain;
}

.dc-layers-view li .eye-hidden {
  width: 15px;
  height: 15px;
  display: block;
  margin: 5px 20px 5px 5px;
  background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4BAMAAADLSivhAAAAElBMVEUAAAAAAAAAAAAAAAAAAAAAAADgKxmiAAAABnRSTlMA\/\+SYFU6oDnW5AAADSElEQVR4nO1YS5biMAzM6wkHyIc9JMw\+aWCfHpo9DHD\/q0w\+2CrJsmOYVb8XrcBxSSXJsi0nySKLLPITJP1\+PO7dO8jzvspGyevj\/TWbt22GUh\/jCZw4dLQfCU\/\/OtARHkN\+1arYXn7PGl\+5lK0Ul\/exPfUgOvVyfqIPAfAMNojW4xzH\/Nc81otOg8GyUnQa\+BqFzbL1u6RHUYLWRoNdt\/9EY3u334uWTvwVwz1xHvGXDPcVFhHqqvIpxZi1CrX9vd\+PPj1gSPbK\/TrsO\/6NAU1fHbPDphMsbjItZ417BituR48NuAzXtPaHAq0NqHY82Omsp\+U3aDyQ\+YNE5zrri0nAGlgVzhbVaKwPdvCCWWxk\/KaQfSljgyvT\+v\+w48LIFDLG51lvaf\+z5GugkwWwec6TpEcrG6vG\+MjdxpCMYkr16oLXzrLphMsNJEDQHnLDiQsuZtGt6A8Ru8gjpeRZNst9REzhvDJW0kfF8NOVYQXC\/lQ6qekQbOtsMjeYJsOTala9DYBpV3zqLx54fBVOIZQAbiSYS5FI0\+tEfNRKZZLcUZwTeBcHxoATuCOwhu2nOqbtRDz9guAPGDE\/GgCHaGPqDZgdIUEwZMuA2ZndamCbjdX\/gOmz\+cVoXzUwqbeVaSdiwL40cGk\/W952IvJWT81GAZuJyFs5\+fBsI9p2k9qEc5XT15aGzE\+8p1xdMLlleRUwEY57xWly2YazhIkQstQF25DQ8mxgIobM4U2aiVUH\/mNFO7yVbaZgkUfTLccWitodz6rfNBkmhy7citdrJU\+GDB1BYBqPFrihk85SamNr1KYELsmwcM0gGQHT9hKH3RgZtiGk6LCbeH993Oash4UwbuwgFYLWQpAQRXAQTu3GD8VpuJa3mkopeK1A90CnbCE00tw7bDJ2Hiyet7zDwbuK3m6eYIYIK5pWG0Z2j5ITULGCZlg3ny2iJXP2hKEkhO\+3\/HHjxr5pEeX3u4IeN868yVFzKe\/j9fH\+nXyfZX\/k6b\/DjxVGfO8Gp3kobwWZzL856G1\/HDqETVJf9zhJ\+JEmjJ7BBpnPPS0NcvNg65C\/Vs6tRvkYA03cV8BMrvVX4PkxwltOfv9ZbbOqqvevPV4ussgiP1L\+AQ8hBe9YslSuAAAAAElFTkSuQmCC') center center no-repeat;
  background-size: contain;
  filter: invert();
}

.dc-layers-view li .layer-name {
  padding: 0px;
  line-height: 25px;
}

.action-list {
  background: #f6f6f6;
  max-width: 80px;
  width: 40px;
  padding: 5px 5px 0px 0px;
  padding: 5px;
  border: 1px solid rgb(232, 232, 232);
}

.action-list [type=radio] + img {
  cursor: pointer;
  width: 30px;
  height: 30px;
  padding: 5px;
  border: 1px solid rgb(232, 232, 232, 0);
}

.action-list [type=radio]:checked + img {
  background: rgb(230, 230, 230, 1);
  border-radius: 5px;
  border: 1px solid rgb(200, 200, 200);
}

.action-list [type=radio]:hover + img {
  background: rgb(234, 234, 234, 0.5);
  border-radius: 5px;
}

.action-list [type=radio] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

@media only screen and (min-width: 768px) {
  .action-list {
    width: 72px;
  }
}
</style>
